import { CaretDownOutlined } from '@ant-design/icons';
import { Add, Delete } from '@mui/icons-material';
import DragIndicatorIcon from '@mui/icons-material/DragIndicator';
import { Autocomplete, Button, Checkbox, FormControl, FormControlLabel, FormGroup, FormHelperText, IconButton, InputLabel, MenuItem, Radio, RadioGroup, Select, Switch, TextField, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { styled as muiStyled } from '@mui/material/styles';
import * as Sentry from '@sentry/react';
import { Col, Collapse, Drawer, Row, Modal, Card, Button as AntButton } from 'antd';
import Acent from 'components/Acent';
import PictureAssignment from 'components/Image/PictureAssignment';
import Loading from 'components/Loading';
import MultiSelect from 'components/MultiSelectorSearch';
import TextEditor from 'components/TextEditor';
import { useTabletDetection } from 'containers/chat/hooks';
import AudioRecorder from "features/AudeoRecorderNew";
import { AssignmentFormFillInBlanksComp, AssignmentVideo } from 'features/forms/assignment';
import { validateMatchMaking, isQuestionEmpty, assignmentDraftHasUserContent } from 'features/forms/assignment/studentMatchMaking/helper';
import { cloneDeep, filter, find, get, has, map } from "lodash";
import AssignmentPhotoCollage from 'modules/activityModule/photoCollage';
import React, { useCallback, useEffect, useEffectEvent, useMemo, useRef, useState } from 'react';
import { useCollectionActivity } from 'utils/methods/firebaseActivity';
import debounce from 'lodash/debounce';
import { connect, useDispatch } from 'react-redux';
import { handleCreateActivities, handleUpdateActivities } from "store/activities/thunks";
import { useApExams } from 'store/apexams/selectors';
import { useBookOrder } from 'store/books/selectors';
import { handleCreateQuizzes, handleUpdateQuizzes } from "store/quizzes/thunks";
import { handleAudioTranscript, handleVideoTranscript } from 'store/submissions/thunks';
import { handleGetAiOptionForAnswer } from 'store/vocabulary/thunks';
import styled from 'styled-components';
import { DURATIONS, imageUpload, photoCollageData, QUESTION_TYPE_ACTIVITY_NON_NATIVE, STANDARD_GRADE_LEVEL } from 'utils/config/reference';
import { default as COLOR, default as color } from 'utils/constants/color';
import { ebookConfigDinamic, isVideo, mapBookByOrderOnlyCreateUser, removeQuestionError } from 'utils/lib/ebookHelper';
import { filterDuplicateWords, removeCustomDuplicates } from 'utils/methods/math';
import AudioPicker from "./AudioPicker";
import AudioMultipleChoice from './AudioWithMultichoice';
import AudioWithEssay from 'modules/activityModule/audioWithWrittenResponse/AudioWithEssay';
import MatchMaking from './PageToolbarModals/MatchMaking';
import AutoSelectStandardsModal from './PageToolbarModals/AutoSelectStandardsModal';
import InfoOutlineIcon from '@mui/icons-material/InfoOutline';
import { DndContext, closestCenter, PointerSensor, useSensor, useSensors } from '@dnd-kit/core';
import { arrayMove, SortableContext, useSortable, verticalListSortingStrategy } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { useAlertLoading } from 'components/UI/alertSakeBar/alertProvider';
import { useStandards, useStory } from "store/story/selectors";
import ModalMenu from 'components/Modals';
import { compareGradesForIllinoisCommonCore, normalizeStateForComparison, statesMatch, getStateNameFromCode, getStateNameDisplayForCode } from 'utils/lib/standardHelper';
import { handleAutoSelectStandardsForAllQuestions } from 'store/story/thunks';
import { InfoOutlined } from '@mui/icons-material';
import StandardsModal from 'components/StandardsModal';
import { useRubrices } from 'store/rubric/selectors';
import { deleteDoc, doc } from 'firebase/firestore';
import { useFirebase } from 'containers/FirebaseContext';
import PictureAssignmentType from 'features/forms/assignment/picture';
import { useStandardExams } from 'store/standardexams';
import useIsExamActive from 'components/hooks/books/useIsExamActive';
import { checkStandardExam } from 'utils/methods/textMethod';
import { useAdminActivityLogger } from 'components/hooks/useAdminActivityLogger';
import SentryWrap from 'components/Sentry';
import { useOrgStandardCodes } from 'store/organizations/selectors';
import { useResources } from 'store/resources/selectors';
import { useBookUnits } from 'store/booksUnits/selectors';

//  ----------------------------------------------------------------------------
//  Styles
//  ----------------------------------------------------------------------------
const LABEL = ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j']

const EXAM_LABELS_FULL = ['Reading Only', 'Reading and Listening', 'Listening Only', 'Email Response', 'Essay (Argumentative)', 'Simulated Conversation', 'Cultural Comparison']
const EXAM_TYPE_LABEL = ['Reading', 'Speaking', 'Listening', 'Writing'];
const AI_GRADED_QUESTION_TYPES = ['essay', 'email', 'picture', 'audio', 'video', 'twoMinAudio', 'audioEssay', 'audioToImage', 'photoCollage'];
const BOOK_CONTENT_REF = [{
    title: "No content",
    value: 'no_content'
},
{

    title: "Book AI content",
    value: "book_ai_content"
},
{
    title: "Book page images",
    value: "book_page_images"
}
]
const Container = styled.div`
    width: 100%;
`;

const Description = styled.span`
    color: ${COLOR.black300};
    display: block;
    font-size: 13px;
    font-weight: 400;
    line-height: 18px;
    margin-bottom: 25px;
`;

const Header = styled(Description)`
    color: ${COLOR.black100};
    font-size: 28px;
    font-weight: 600;
    line-height: 28px;
    margin-bottom: 16px;
`;

const Wrapper = styled.div`
    margin: 0px auto;
    width: 100%;
    position: relative;
    top: 0px;
`;
const AssignmentDescription = styled.span`
    color: ${COLOR.black300};
    display: block;
    font-size: 12px;
    font-weight: 400;
    line-height: 17px;
`;

const Image = styled.img`
    background-color: ${COLOR.white};
    box-shadow: 0 10px 20px rgba(0,0,0,0.19), 0 6px 6px rgba(0,0,0,0.23);
    height: auto;
    width: 100%;
`;

const ImageContiner = styled.div`
    background-color: transparent;
    border: none;
    flex: 1;
    outline: none;
    width: 100%;
    height:100%;
    margin-right: 16px;
    padding-right: 10px;
`;

const RelativeContainer = styled.div`
    position: relative;
    width: 100%;
    padding: 10px;
    margin: 2px;
    border: 1px dashed;
    margin-top:16px;
    margin-bottom:16px;
`;
const SortableRow = styled.div`
    align-items: center;
    border: 1px solid #e0e0e0;
    border-radius: 6px;
    display: flex;
    gap: 12px;
    margin-bottom: 8px;
    padding: 12px 16px;
    background: #fafafa;
    cursor: grab;
    &:active {
        cursor: grabbing;
    }
`;
const AssignmentTitle = styled.span`
    color: ${COLOR.black100};
    display: block;
    font-size: 16px;
    font-weight: 600;
    line-height: 18px;
`;
const Question = styled(AssignmentTitle)`
    font-size: 16px;
    line-height: 22px;
`;

const QuestionContainer = styled(Container)`
    margin-top: 0px;
    position: relative;
`;

const useStyles = makeStyles((theme) => ({
    root: {
        marginBottom: '25px',
        width: '300px'
    },
    rootDif: {
        width: '200px'
    },
    rootDifFull: {
        width: "100%"
    },
    sizeSmall: {
        width: '55px',
        height: '25px'
    },
    checkedSwitch: {
        transform: 'translateX(30px) !important'
    },
    label: {
        textTransform: 'uppercase',
    },
    formControl: {
        minWidth: 120
    },
    colorPrimary: {
        color: `${COLOR.green}!important`
    },
    checkroot: {
        display: 'flex',
        flexDirection: 'column'
      },
      checkformControl: {
        minWidth: 300,
      },
      checksectionTitle: {
      },
      formGroup: {
        flexDirection: 'row', // Arrange checkboxes in a row
        gap:12
      },
      checkbox: {
        '&.Mui-checked': {
          color: color.green100, // Custom checked color (green)
        },
      },
}));

const StyledFormControl = muiStyled(FormControl)(({ theme }) => ({
  minWidth: 120,
  width: '100%',
  margin: '10px 0',
}));

const StyledInputLabel = muiStyled(InputLabel)({
  backgroundColor: 'white',
  paddingRight: 5,
});

const Content = styled.div`
    margin-top: 14px;
`;

const Detail = styled(AssignmentDescription)`
    color: ${COLOR.black600};
    display: inline-block;
    font-size: 10px;
    font-weight: 600;
    text-transform: uppercase;
    margin-top:${p => p.index == 0 ? "opx" : "24px"}
`;

const InnerWrapper = styled.div`
        padding: 0px;
        width: 100%;
        overflow-y:scroll;
        overflow-x: hidden;
        scroll-behavior: smooth;
        padding-bottom: 5px;
        max-height:60vh;
        border-bottom: 1px dotted;
        padding-right: 6px;
        ::-webkit-scrollbar {
            width: 5px;
            height: 3px;
          }
`;
const RadioColumn = styled(Col)`
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    padding-top: 22px;
`

const AiconfigWrapper = styled.div`
        padding: 24px;
        width: 100%;
        border: 1px solid #e0e0e0;
        border-radius: 8px;
        min-height: 50px;
        position: relative;
        margin-bottom: 16px;
        background: #fafafa;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
`;
const AiConfigArea = styled.div`
    position: absolute;
    top: -12px;
    left: 16px;
    background: white;
    padding: 0 8px;
    font-weight: 600;
    font-size: 14px;
    color: #1976d2;
    letter-spacing: 0.5px;
`;
const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
        },
    },
};

function getStyles(name, studentsName, theme) {
    return {
        fontWeight:
            studentsName.indexOf(name) === -1
                ? theme.typography.fontWeightRegular
                : theme.typography.fontWeightMedium,
    };
}

function filterOrdersByOrderIds(oneArray, orderIds) {
    const filteredOrders = [];
    for (const orderItem of oneArray) {
      if (
        orderItem.order?.some((itemId) => orderIds === itemId)
      ) {
        filteredOrders.push(orderItem);
      }
    }
  
    return filteredOrders;
  }

//  ----------------------------------------------------------------------------
//  Component
//  ----------------------------------------------------------------------------
//
//  Quiz form
//
//  -- Description
//  Create / edit quiz questions
//
//  -- Props
//  handleChange {func} - invoked on input change
//  handleSubmit {func} = invoked on submit
//
//  -- State
//  ...
//
//  -- Methods
//  ...
//
//  -- Usage
//  <AssignmentForm
//      data={data}
//      handleChange={func}
//      handleSubmit={func}
//  />
//

const CheckCreteia = ({ creteria ={} , onCreteriaChange=()=>{},show_page_input}) => {
    const classes = useStyles();
    const [selectedSections, setSelectedSections] = React.useState({
        sentenceStructure: false,
        grammar: false,
        orthography: false,
        sectionContent: false
    });
    useEffect(() => {
        if (creteria && Object.keys(creteria).length > 0) {
            setSelectedSections(creteria)
        }
    }, [creteria])
    const handleChange = (event) => {
        setSelectedSections({
          ...selectedSections,
          [event.target.name]: event.target.checked,
        });
        onCreteriaChange({
            ...selectedSections,
            [event.target.name]: event.target.checked,
        })
      };
    return (<div className={classes.checkroot}>
        <Typography variant="subtitle2" className={classes.checksectionTitle}>
            Teacher AI Open-Ended Auto Grading
        </Typography>
        <FormControl component="fieldset" className={classes.checkformControl}>
            <FormGroup className={classes.formGroup}>
                <FormControlLabel
                    control={
                        <Checkbox
                            checked={selectedSections.sentenceStructure}
                            onChange={handleChange}
                            className={classes.checkbox}
                            name="sentenceStructure"
                            color="primary"
                        />
                    }
                    label="Sentence Structure"
                />
                <FormControlLabel
                    control={
                        <Checkbox
                            checked={selectedSections.grammar}
                            onChange={handleChange}
                            className={classes.checkbox}
                            name="grammar"
                            color="primary"
                        />
                    }
                    label="Grammar"
                />
                <FormControlLabel
                    control={
                        <Checkbox
                            checked={selectedSections.orthography}
                            onChange={handleChange}
                            className={classes.checkbox}
                            name="orthography"
                            color="primary"
                        />
                    }
                    label="Orthography"
                />
                {show_page_input ? <FormControlLabel
                    control={
                        <Checkbox
                            checked={selectedSections.sectionContent}
                            onChange={handleChange}
                            className={classes.checkbox}
                            name="sectionContent"
                            color="primary"
                        />
                    }
                    label="Section Content"
                /> : null}
            </FormGroup>
        </FormControl>
    </div>)
}

const pageMatchesConfigId = (page, raw) => {
    if (page == null || raw == null || raw === '') return false
    const a = parseInt(page.pageId, 10)
    const b = parseInt(raw, 10)
    if (!Number.isNaN(a) && !Number.isNaN(b)) return a === b
    return String(page.pageId) === String(raw)
}

const pageDisplayLabel = (page) => {
    if (!page || typeof page !== 'object') return ''
    const masked = page.NumberMasked
    if (masked != null && String(masked).trim() !== '') return String(masked)
    return page.pageId != null ? String(page.pageId) : ''
}

const AiConfiguration = ({ config, onChangeConfig, pages = [] }) => {
    const dispNameRef = useRef();
    const classes = useStyles();
    const show_page_input = config.content_type === "book_ai_content" || config.content_type === "book_page_images"
    const pageList = pages || []
    const fromIndex =
        config.from_page != null && config.from_page !== ''
            ? pageList.findIndex(p => pageMatchesConfigId(p, config.from_page))
            : -1
    const toPageOptions = fromIndex >= 0 ? pageList.slice(fromIndex) : []
    const toIndex =
        config.to_page != null && config.to_page !== ''
            ? pageList.findIndex(p => pageMatchesConfigId(p, config.to_page))
            : -1
    const fromPageValue =
        fromIndex >= 0 ? pageList[fromIndex] : null
    const toPageValue =
        fromIndex >= 0 && toIndex >= fromIndex ? pageList[toIndex] : null
    return (<AiconfigWrapper>
        <AiConfigArea>AI Grading Configuration</AiConfigArea>
        <Row gutter={[16, 16]} style={{ marginTop: 16 }}>
            <Col span={show_page_input ? 8 : 24}>
                <FormControl variant="outlined" className={classes.formControl} fullWidth>
                    <InputLabel id="type">Content Type</InputLabel>
                    <Select
                        labelId="type"
                        id="type"
                        value={config.content_type || 'no_content'}
                        required
                        onChange={(v) => {
                            onChangeConfig({ ...config, content_type: v.target.value, from_page: '', to_page: '', });
                        }}
                        label="Content Type"
                    >
                        {BOOK_CONTENT_REF.map(v => (
                            <MenuItem key={v.value} value={v.value}>{v.title}</MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </Col>
            {show_page_input && (
                <>
                    <Col span={8}>
                        <FormControl variant="outlined" className={classes.formControl} fullWidth>
                            <Autocomplete
                                id="from_page"
                                options={pageList}
                                getOptionLabel={(option) => pageDisplayLabel(option)}
                                isOptionEqualToValue={(option, value) => {
                                    if (!option || !value) return false
                                    return parseInt(option.pageId, 10) === parseInt(value.pageId, 10)
                                }}
                                value={fromPageValue}
                                onChange={(event, newValue) => {
                                    onChangeConfig({
                                        ...config,
                                        from_page: newValue ? newValue.pageId : '',
                                        to_page: '',
                                    })
                                }}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="From Page"
                                        variant="outlined"
                                        sx={{
                                            '& .MuiOutlinedInput-root': { padding: '0px' },
                                            '& .MuiOutlinedInput-input': { padding: '14px 14px' },
                                        }}
                                    />
                                )}
                            />
                        </FormControl>
                    </Col>
                    <Col span={8}>
                        <FormControl variant="outlined" className={classes.formControl} fullWidth>
                            <Autocomplete
                                id="to_page"
                                options={toPageOptions}
                                getOptionLabel={(option) => pageDisplayLabel(option)}
                                isOptionEqualToValue={(option, value) => {
                                    if (!option || !value) return false
                                    return parseInt(option.pageId, 10) === parseInt(value.pageId, 10)
                                }}
                                value={toPageValue}
                                onChange={(event, newValue) => {
                                    onChangeConfig({
                                        ...config,
                                        to_page: newValue ? newValue.pageId : '',
                                    })
                                }}
                                disabled={fromIndex < 0}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="To Page"
                                        variant="outlined"
                                        placeholder={
                                            fromIndex < 0
                                                ? "Select 'From Page' first"
                                                : 'Select ending page (same order as book)'
                                        }
                                        sx={{
                                            '& .MuiOutlinedInput-root': { padding: '0px' },
                                            '& .MuiOutlinedInput-input': { padding: '14px 14px' },
                                        }}
                                    />
                                )}
                            />
                        </FormControl>
                    </Col>
                </>
            )}
        </Row>
       
        <Row style={{ marginTop: 24 }}>
            <Col span={24}>
                <CheckCreteia 
                    creteria={config.creteria || []} 
                    onCreteriaChange={v => onChangeConfig({ ...config, creteria: v })} 
                    show_page_input={show_page_input} 
                />
            </Col>
        </Row>
        
        <Row style={{ marginTop: 24 }}>
            <Col span={24}>
                <div style={{ display: "flex", alignItems: "flex-start", gap: 8, position: "relative", width: "100%", flexDirection: "column" }}>
                    <Acent 
                        inputRef={dispNameRef} 
                        setValue={v => onChangeConfig({ ...config, teacher_instruction: v })} 
                        style={{ flexShrink: 0 }} 
                    />
                    <TextField
                        id="displayName"
                        name="displayName"
                        label="Prompt for AI"
                        slotProps={{ inputLabel: { shrink: true } }}
                        type="text"
                        inputRef={dispNameRef}
                        multiline
                        rows={2}
                        variant="outlined"
                        fullWidth
                        onChange={e => {
                            onChangeConfig({ ...config, teacher_instruction: e.target.value })
                        }}
                        value={config.teacher_instruction}
                    />
                </div>
            </Col>
        </Row>

    </AiconfigWrapper>)
}
function ensureQuestionUids(questionsList) {
    if (!Array.isArray(questionsList)) return questionsList;
    return questionsList.map(q => ({
        ...q,
        _uid: q._uid || `q-${Math.random().toString(36).slice(2)}`,
    }));
}
function getQuestionPreviewText(question) {
    if (!question || !question.question) return '';
    const raw = typeof question.question === 'string' ? question.question : '';
    return raw.replace(/<[^>]*>/g, '').trim().slice(0, 60) || 'Question';
}
function SortableQuestionItem({ question, index, sortableId }) {
    const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({ id: sortableId });
    const style = {
        transform: CSS.Transform.toString(transform),
        transition,
        opacity: isDragging ? 0.5 : 1,
    };
    return (
        <SortableRow ref={setNodeRef} style={style} {...attributes} {...listeners}>
            <DragIndicatorIcon style={{ color: '#999' }} />
            <span style={{ fontWeight: 600, minWidth: 90 }}>Question {question.id ?? index + 1}</span>
            <span style={{ flex: 1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', fontSize: 13, color: '#666' }}>
                {getQuestionPreviewText(question)}
            </span>
            <span style={{ fontSize: 12, color: '#1976d2', fontWeight: 500, whiteSpace: 'nowrap' }}>
                New order: {index + 1}
            </span>
        </SortableRow>
    );
}
function RearrangeQuestionsList({ reorderList, setReorderList }) {
    const sensors = useSensors(
        useSensor(PointerSensor, { activationConstraint: { distance: 8 } })
    );
    const sortableIds = reorderList.map((q, i) => q._uid ?? q.id ?? `q-${i}`);
    const handleDragEnd = (event) => {
        const { active, over } = event;
        if (!active || !over || active.id === over.id) return;
        const oldIndex = reorderList.findIndex((q, i) => (q._uid ?? q.id ?? `q-${i}`) === active.id);
        const newIndex = reorderList.findIndex((q, i) => (q._uid ?? q.id ?? `q-${i}`) === over.id);
        if (oldIndex === -1 || newIndex === -1) return;
        setReorderList(arrayMove(reorderList, oldIndex, newIndex));
    };
    return (
        <DndContext sensors={sensors} collisionDetection={closestCenter} onDragEnd={handleDragEnd}>
            <SortableContext items={sortableIds} strategy={verticalListSortingStrategy}>
                <div style={{ padding: '8px 0', maxHeight: 400, overflowY: 'auto' }}>
                    <div style={{ marginBottom: 12, fontSize: 13, color: '#666' }}>
                        Drag to reorder. "New order" shows the position (1, 2, 3…) after rearranging.
                    </div>
                    {reorderList.map((question, index) => (
                        <SortableQuestionItem
                            key={question._uid ?? question.id ?? `q-${index}`}
                            question={question}
                            index={index}
                            sortableId={question._uid ?? question.id ?? `q-${index}`}
                        />
                    ))}
                </div>
            </SortableContext>
        </DndContext>
    );
}
const AssignmentForm = ({
    pageSrc,
    data,
    bookId,
    pageId,
    type,
    onCreateOrUpdate,
    booksAllList,
    activities,
    draftId,
    setDraftId,
    open,
    onClose,
    openedFromDraftCard = false,
    configEngageMent = {},
    isDisableDraft = false,
    pageCoverEngage = null,
    currentUser
}) => {
    const refreshAssignmentKey = useMemo(() => {
      const activityKey = data?.id || data?.docId || 'new';
      return `assignment-form-refresh-backup-${bookId}-${pageId}-${activityKey}`;
    }, [data?.id, data?.docId, bookId, pageId]);
    const {setAlertLoading, showAlert} = useAlertLoading();
    const [buttonDisabled,setButtonDisabled] = useState(false);
    const classes = useStyles();
    const resources = useResources();
    const isVideoAvailable = useMemo(() => isVideo(bookId, resources), [bookId, resources]);
    const AllRubricsData = useRubrices();
    const { logBookToolActivity } = useAdminActivityLogger();
    const assignmentType = type ? type : get(data, "typeId", '')
    const [questions, setQuestions] = useState([])
    const [displayName, setdisplayName] = useState('')
    const [is_exam, setIsExam] = useState(false);
    const [isUnitExam, setIsUnitExam] = useState(false);
    const [colorCode, setcolorCode] = useState('')
    const [storyType, setStoryType] = useState(false)
    const [apExamType, setApExamType] = useState(false)
    const [examCategories, setExamCategories] = useState('')
    const [loading, setLoading] = useState(false)
    const [level, setlevel] = useState(null)
    const [unit, setUnit] = useState(null);
    const [unit_exam, setUnitExam] = useState(null)
    const [languageFeedback, setLanguageFeedback] = useState('SPANISH')
    const [assignmentStandards, setAssignmentStandards] = useState([])
    const [errors, setError] = useState([])
    const dispatch = useDispatch()
    const isEditing = has(data, "id") && (data.docId !== draftId || data?.id);
    const standards = useStandards()
    const enabledStateCodes = useOrgStandardCodes();
    const story = useStory()
    const bookOrder = useBookOrder()
    const isStoryBook = Boolean(find(story, ["bookId", bookId]))
    const innerRef = useRef(null)
    const exams = useApExams()
    const isApExams = Boolean(find(exams, k => find(k.exams, c => c.bookId == bookId)))
    const standard_exams = useStandardExams();
    const isStandardExam = useMemo(() => checkStandardExam(bookId,standard_exams), [bookId,standard_exams])
    const dispNameRef = useRef();
    const questionRefs = useRef([]);
    const optionRefs = useRef([]);
    const answerRefs = useRef([]);
    const {structures} = ebookConfigDinamic(bookId, booksAllList);
    const orderedBook = mapBookByOrderOnlyCreateUser(booksAllList, filterOrdersByOrderIds(bookOrder, bookId))[0]?.books || []; 
    const getBookData = find(booksAllList, (book) => book.id === bookId);
    const filteredUnits = structures.find(unit => pageId >= parseInt(unit.start) && pageId <= parseInt(unit.finish)) || {};
    const [ai_grading_config,setAi_grading_config] = useState({})
    const isTablate = useTabletDetection();
    const bookPages = getBookData?.pages || [];
    const pageIdToBookIndex = useMemo(() => {
        const m = new Map();
        bookPages.forEach((p, i) => {
            const id = parseInt(p.pageId, 10);
            if (!Number.isNaN(id) && !m.has(id)) m.set(id, i);
        });
        return m;
    }, [bookPages]);
    const defaultPageSelection = useMemo(() => {
        const current = parseInt(pageId, 10);
        const exists = bookPages.some(p => parseInt(p.pageId, 10) === current);
        if (exists) return current;
        const first = bookPages[0]?.pageId;
        return first != null ? parseInt(first, 10) : 1;
    }, [pageId, bookPages]);
    const validPageSelectionValue = (val) => {
        const n = parseInt(val ?? defaultPageSelection, 10);
        return bookPages.some(p => parseInt(p.pageId, 10) === n) ? n : defaultPageSelection;
    };
    useEffect(() => {
        if (ai_grading_config.page_selection_from == null && ai_grading_config.page_selection_to == null && pageId != null && bookPages.length > 0) {
            setAi_grading_config(prev => ({
                ...prev,
                page_selection_from: defaultPageSelection,
                page_selection_to: defaultPageSelection
            }));
        }
    }, [pageId, bookPages.length, defaultPageSelection]);
    const [rubrics, setRubrics] = useState(null);
    const [inputValue, setInputValue] = useState({});
    const bookActivities = filter(activities, ac => ac.bookId == bookId) || [];
    const [optionStates, setOptionStates] = useState({}); 
    const [standardInfoModal, setStandardInfoModal] = useState({ open: false, standardAbbrs: [], stateStandard: null });
    const [pageLinkConfiguration, setPageLinkConfiguration] = useState(false);
    const [rearrangeModalOpen, setRearrangeModalOpen] = useState(false);
    const [reorderList, setReorderList] = useState([]);
    const { createDraftActivity } = useCollectionActivity();
    const { firestore } = useFirebase();
    const bookUnitList = useBookUnits()
    const [configAssignment, setConfigAssignment] = useState(configEngageMent || {})

    const matchedReadLessonPage = useMemo(() => {
        const data = find(bookUnitList, ["bookId", bookId]);
        if (!data) return null;
        const pages = get(data, "pages", []);
        const current = Number(pageId);
        if (Number.isNaN(current)) return null;
        return find(pages, page => {
            const start = Number(page.start);
            const finish = Number(page.finish);
            return current >= start && current <= finish;
        }) || null;
    }, [bookUnitList, bookId, pageId]);

    const readLessonPagePool = useMemo(() => {
        if (!matchedReadLessonPage) return bookPages;
        const lo = Number(matchedReadLessonPage.start);
        const hi = Number(matchedReadLessonPage.finish);
        const filtered = bookPages.filter(p => {
            const n = parseInt(p.pageId, 10);
            return n >= lo && n <= hi;
        });
        return filtered.length > 0 ? filtered : bookPages;
    }, [bookPages, matchedReadLessonPage]);

    const validReadLessonPageSelection = (val) => {
        const pool = readLessonPagePool;
        const fallback = parseInt(pool[0]?.pageId, 10);
        const fb = Number.isFinite(fallback) ? fallback : defaultPageSelection;
        const n = parseInt(val ?? defaultPageSelection, 10);
        return pool.some(p => parseInt(p.pageId, 10) === n) ? n : fb;
    };

    const resolveReadLessonPageValue = (val) =>
        matchedReadLessonPage ? validReadLessonPageSelection(val) : validPageSelectionValue(val);

    const readLessonPageIdToIndex = useMemo(() => {
        const m = new Map();
        readLessonPagePool.forEach((p, i) => {
            const id = parseInt(p.pageId, 10);
            if (!Number.isNaN(id) && !m.has(id)) m.set(id, i);
        });
        return m;
    }, [readLessonPagePool]);

    const effectivePageSelectionToValue = useMemo(() => {
        const fp = resolveReadLessonPageValue(ai_grading_config.page_selection_from);
        const tp = resolveReadLessonPageValue(ai_grading_config.page_selection_to);
        const fi = readLessonPageIdToIndex.get(fp) ?? 0;
        const ti = readLessonPageIdToIndex.get(tp) ?? 0;
        const p = readLessonPagePool[Math.max(fi, ti)];
        return p ? parseInt(p.pageId, 10) : fp;
    }, [
        ai_grading_config.page_selection_from,
        ai_grading_config.page_selection_to,
        readLessonPagePool,
        readLessonPageIdToIndex,
        matchedReadLessonPage,
        defaultPageSelection,
        bookPages
    ]);

    useEffect(() => {
        if (!pageLinkConfiguration || !matchedReadLessonPage) return;
        const fromV = validReadLessonPageSelection(ai_grading_config.page_selection_from);
        const toV = Math.max(fromV, validReadLessonPageSelection(ai_grading_config.page_selection_to));
        const cf = Number(ai_grading_config.page_selection_from);
        const ct = Number(ai_grading_config.page_selection_to);
        if (cf !== fromV || ct !== toV) {
            setAi_grading_config(prev => ({ ...prev, page_selection_from: fromV, page_selection_to: toV }));
        }
    }, [
        pageLinkConfiguration,
        matchedReadLessonPage,
        readLessonPagePool,
        ai_grading_config.page_selection_from,
        ai_grading_config.page_selection_to
    ]);

    useEffect(() => {
        if (!pageLinkConfiguration) return;
        if (matchedReadLessonPage) {
            const fromVal = validReadLessonPageSelection(ai_grading_config.page_selection_from);
            const toVal = validReadLessonPageSelection(ai_grading_config.page_selection_to);
            const poolIdToIdx = new Map();
            readLessonPagePool.forEach((p, i) => {
                const id = parseInt(p.pageId, 10);
                if (!Number.isNaN(id) && !poolIdToIdx.has(id)) poolIdToIdx.set(id, i);
            });
            const fromIdx = poolIdToIdx.get(fromVal) ?? 0;
            const toIdx = poolIdToIdx.get(toVal) ?? 0;
            if (toIdx < fromIdx) {
                setAi_grading_config(prev => ({ ...prev, page_selection_to: fromVal }));
            }
            return;
        }
        const fromVal = validPageSelectionValue(ai_grading_config.page_selection_from);
        const toVal = validPageSelectionValue(ai_grading_config.page_selection_to);
        const fromIdx = pageIdToBookIndex.get(fromVal) ?? 0;
        const toIdx = pageIdToBookIndex.get(toVal) ?? 0;
        if (toIdx < fromIdx) {
            setAi_grading_config(prev => ({ ...prev, page_selection_to: fromVal }));
        }
    }, [
        pageLinkConfiguration,
        matchedReadLessonPage,
        readLessonPagePool,
        ai_grading_config.page_selection_from,
        ai_grading_config.page_selection_to,
        pageIdToBookIndex,
        bookPages,
        defaultPageSelection
    ]);

    const getAiGradingConfigForPayload = (config, pageLinkEnabled) => {
        if (!pageLinkEnabled) {
            const { page_selection_from, page_selection_to, ...rest } = config || {};
            return rest;
        }
        const c = config || {};
        const rawFrom = c.page_selection_from ?? defaultPageSelection;
        const rawTo = c.page_selection_to ?? defaultPageSelection;
        const fromSel = matchedReadLessonPage ? validReadLessonPageSelection(rawFrom) : validPageSelectionValue(rawFrom);
        const toSel = matchedReadLessonPage ? validReadLessonPageSelection(rawTo) : validPageSelectionValue(rawTo);
        return {
            ...c,
            page_selection_from: fromSel,
            page_selection_to: Math.max(fromSel, toSel)
        };
    }

    const originalDataRef = useRef(null);
    const initializedDataIdRef = useRef(null);
    const skipDeleteAfterDraftSaveRef = useRef(false);
    const isExamActive = useIsExamActive({bookId});
    const checkExamBookType = useMemo(() => isExamActive?.checkExamBookType || false, [isExamActive,bookId]);

    const saveDraftRef = useRef(
      debounce(async (draftId, draftData) => {
        if (!draftId) return;
        if (!assignmentDraftHasUserContent(draftData)) return;
        try {
          await createDraftActivity(draftId, draftData);
        } catch (error) {
          console.error('Error saving draft:', error);
        }
      }, 700, { leading: true, trailing: true, maxWait: 1200 }),
    );

    const prepareDraftData = () => {
      try {
        return {
          chapter: bookId,
          bookId: bookId,
          displayName: displayName,
          page: pageId,
          typeId: assignmentType ? assignmentType : 'activity',
          questions: (questions || []).map(({ _uid, ...q }) => q),
          colorCode: colorCode,
          level: level,
          type: storyType ? 'story' : apExamType ? 'apexam' : '',
          category: examCategories,
          language_feedback: languageFeedback,
          is_exam,
          is_unit_exam: isUnitExam,
          unit: isUnitExam ? unit : '',
          unit_exam: isUnitExam ? unit_exam : '',
          ai_grading_config: getAiGradingConfigForPayload(ai_grading_config, pageLinkConfiguration),
          rubrics_id: rubrics,
          pageLinkConfiguration,
          config_assignment: configAssignment || {},
          standards: assignmentStandards && assignmentStandards.length > 0 ? assignmentStandards : []
        };
      } catch (error) {
        return {};
      }
    };

    const saveDraftOnPageExit = useEffectEvent(() => {
      const hasContent = assignmentDraftHasUserContent({ displayName, questions });
      const changedInEdit = !(isEditing && originalDataRef.current && !hasDataChanged());
      if (!hasContent) return;
      if (!changedInEdit) return;
      try {
        saveDraftRef.current?.cancel?.();
        const draftData = prepareDraftData();
        if (draftId) {
          createDraftActivity(draftId, draftData);
        }
        window.sessionStorage.setItem(refreshAssignmentKey, JSON.stringify({ draftId, draftData }));
      } catch (error) {
        Sentry.captureException(error);
      }
    });
    
    useEffect(() => {
      if (!draftId) return;
      if (isEditing && originalDataRef.current && !hasDataChanged()) return;
      if (!assignmentDraftHasUserContent({ displayName, questions })) {
        saveDraftRef.current?.cancel?.();
        return;
      }
      const draftData = prepareDraftData();
      saveDraftRef.current(draftId, draftData);
    }, [ displayName, questions, colorCode, level, storyType, apExamType, examCategories, languageFeedback, is_exam, isUnitExam, unit, unit_exam, ai_grading_config, rubrics, bookId, assignmentType, draftId, assignmentStandards, pageLinkConfiguration ]);

    useEffect(() => {
      if (!open) return;
      const hasContent = assignmentDraftHasUserContent({ displayName, questions });
      const changedInEdit = !(isEditing && originalDataRef.current && !hasDataChanged());
      if (!hasContent || !changedInEdit) {
        window.sessionStorage.removeItem(refreshAssignmentKey);
        return;
      }
      try {
        const draftData = prepareDraftData();
        window.sessionStorage.setItem(refreshAssignmentKey, JSON.stringify({ draftId, draftData }));
      } catch (error) {
        Sentry.captureException(error);
      }
    }, [open, draftId, displayName, questions, colorCode, level, storyType, apExamType, examCategories, languageFeedback, is_exam, isUnitExam, unit, unit_exam, ai_grading_config, rubrics, bookId, pageId, assignmentType, assignmentStandards, pageLinkConfiguration, isEditing, refreshAssignmentKey]);

    useEffect(() => {
      if (!open) return;
      const handleBeforeUnload = () => {
        saveDraftOnPageExit();
      };
      const handlePageHide = () => {
        saveDraftOnPageExit();
      };
      window.addEventListener('beforeunload', handleBeforeUnload);
      window.addEventListener('pagehide', handlePageHide);
      return () => {
        window.removeEventListener('beforeunload', handleBeforeUnload);
        window.removeEventListener('pagehide', handlePageHide);
      };
    }, [open, saveDraftOnPageExit]);
    
    const selectedRubricData = useMemo(() => find(AllRubricsData, k => k.id == rubrics), [AllRubricsData, rubrics])
    

// get book standard 
    // Filter standards by ebook grade_level
    const filteredStandardsOptions = useMemo(() => {
        // Get ebook grade_level
        const ebookGradeLevel = getBookData?.grade_level;

        // Filter standards by enabled state codes first
        let filteredByState = standards;
        if (enabledStateCodes && enabledStateCodes.length > 0) {
            filteredByState = filter(standards, (standard) => {
                const standardStatus = get(standard, 'status', false);
                if (standardStatus !== true) return false;
                const standardState = get(standard, 'state', '');
                const enabledStateNames = enabledStateCodes.map(code => normalizeStateForComparison(code)).filter(Boolean);
                return enabledStateNames.some(enabledName => statesMatch(standardState, enabledName));
            });
        } else {
            filteredByState = filter(standards, (standard) => {
                const standardStatus = get(standard, 'status', false);
                return standardStatus === true;
            });
        }
        
        // If ebook has grade_level, filter standards by grade
        if (ebookGradeLevel) {
            // Handle comma-separated grade levels (e.g., "1,3,5")
            const ebookGrades = ebookGradeLevel.split(',').map(g => g.trim()).filter(g => g);
            
            return map(
                filter(filteredByState, (standard) => {
                    const standardStatus = get(standard, 'status', false);
                    if (standardStatus !== true) return false;
                    const standardGradeLevel = get(standard, 'grade_level', '');
                    if (!standardGradeLevel) return true;
                    
                    // Handle comma-separated grade levels in standard
                    const standardGrades = standardGradeLevel.split(',').map(g => g.trim()).filter(g => g);
                    const standardState = String(get(standard, 'state', '')).toUpperCase();
                    
                    // Check if any ebook grade matches any standard grade (using normalized comparison)
                    return ebookGrades.some(ebookGrade => 
                        standardGrades.some(standardGrade => compareGradesForIllinoisCommonCore(ebookGrade, standardGrade, standardState))
                    );
                }),
                k => k.abbr
            );
        }
        
        // If no grade_level, show all filtered standards
        return map(filter(filteredByState, (standard) => {
            const standardStatus = get(standard, 'status', false);
            return standardStatus === true;
        }), k => k.abbr);
    }, [standards, getBookData?.grade_level, enabledStateCodes]);
    
    const assignmentStandardsOptions = useMemo(() => {
        return filteredStandardsOptions.map(abbr => ({
            label: abbr,
            value: abbr
        }));
    }, [filteredStandardsOptions]);
    
    const showStandardsField = enabledStateCodes && enabledStateCodes.length > 0;
    
    const renderedGroups = new Set();
    const essayGroupKey = new Set();
    const filteredActivities = bookActivities?.filter(activity => {
        const pageNumber = parseInt(activity.page, 10);
        return (
            pageNumber >= parseInt(filteredUnits?.start, 10) &&
            pageNumber <= parseInt(filteredUnits?.finish, 10) &&
            activity.is_unit_exam === true
        );
    })?.length;
    useEffect(() => {
        if (filteredUnits?.id && orderedBook?.length > 0) {
            setUnit(filteredUnits?.shortName);
            setUnitExam(filteredActivities + 1);
        }
    }, [filteredUnits, filteredActivities])

    useEffect(() => {
        if (!open) {
            initializedDataIdRef.current = null;
        }
    }, [open])
    const trenacriptAudio = (url) => {
        handleAudioTranscript(url)
    }
    const transcriptVideo = (url) => {
        handleVideoTranscript(url)
    }

    const onDeleteDraft = async () => {
      if (!draftId) return;
      try {
        const docRef = doc(firestore, import.meta.env.VITE_APP_STAGE?.trim() === 'prod' ? 'draft_activity_prod' : 'draft_activity', draftId);
        await deleteDoc(docRef);
        logBookToolActivity('delete', 'draft_activity', bookId, pageId, {
            draftId: draftId,
            bookName: getBookData?.name || 'Unknown Book',
            displayName: displayName || 'Untitled Draft'
        });
        setDraftId(null);
      } catch (error) {
        console.error('error', error);
        Sentry.captureException(error);
      }
    };

    const handleCloseAllState = () => {
  try {
    if (isDisableDraft) {
      setQuestions([]);
      setcolorCode('');
      setIsExam(false);
      setIsUnitExam(false);
      setStoryType(false);
      setApExamType(false);
      setExamCategories('');
      setlevel('');
      setUnit('');
      setUnitExam('');
      setLanguageFeedback('');
      setdisplayName('');
      setAi_grading_config('');
      setConfigAssignment('');
      setRubrics(null);
      setAssignmentStandards([]);
      initializedDataIdRef.current = null;
    }
  } catch (error) {
    console.log(error);
  }
};
      
    const onSubmit = async (e) => {
        try{
            const error = []
        const assignmentData = {
            ...data,
            chapter: bookId,
            bookId: bookId,
            displayName: displayName,
            page: pageId,
            typeId: assignmentType ? assignmentType : "activity",
            questions: (questions || []).map(({ _uid, ...q }) => q),
            colorCode: colorCode,
            level: level,
            type: storyType ? 'story' : apExamType ? 'apexam' : '',
            category: examCategories,
            language_feedback: languageFeedback,
            is_exam,
            is_unit_exam: isUnitExam,
            unit: isUnitExam ? unit : '',
            unit_exam: isUnitExam ? unit_exam : '',
            ai_grading_config: getAiGradingConfigForPayload(ai_grading_config, pageLinkConfiguration),
            rubrics_id: rubrics,
            config_assignment: configEngageMent || {},
            standards: assignmentStandards && assignmentStandards.length > 0 ? assignmentStandards : []
        }
        setLoading(true)
        if (assignmentData?.is_unit_exam) {
            if (!assignmentData.unit || !assignmentData.unit_exam) {
                error.push({ type: 'unit_exam', message: 'unit and unit exam both are required' })
            }
        }
        if (!assignmentData.displayName) {
            error.push({ type: 'display_name', message: 'Displayname required' })
        }
        if (isStoryBook && assignmentData.type != "story") {
            error.push({ type: 'story_type', message: `"ASSIGNMENT FOR STORY" must be enabled!` })
        }
        if (isApExams && assignmentData.type != "apexam") {
            error.push({ type: 'story_type', message: `"ASSIGNMENT FOR AP" must be enabled!` })
        }
        if (isApExams && !assignmentData.category) {
            error.push({ type: 'category_ap', message: `"CATEGORY FOR AP" must be selected!` })
        }
        if (isStoryBook && !assignmentData.level) {
            error.push({ type: 'level', message: 'Assignment level required!' })
        }
        if (!assignmentData.language_feedback) {
            error.push({ type: 'language_feedback', message: 'Language feedback required!' })
        }

        if (!Array.isArray(assignmentData.questions) || assignmentData.questions.length == 0) {
            error.push({ type: 'question_error', message: 'Questions are required , please add atleast one question.' })
        } else {
            const questionErrorNumbers = new Set();
            const instructionErrorNumbers = new Set();
            const optionErrorNumbers = new Set();
            const audioErrorNumbers = new Set();
            let hasQuestionError = false
            let hasInstructionError = false
            let hasOptionErrorError = false
            let hasAudioError = false
            const questionErrorIndices = new Set();
            const optionErrorIndices = new Set();
            const audioErrorIndices = new Set();
            assignmentData.questions.map((q, i) => {
                if (q.type === 'multipleChoice' || q.type === 'trueFalse' || q.type =='audioTrueFalse' || q.type === 'audioMultipleChoice' || q.type === 'multipleResponse') {
                    const noOption = filter(q.options, (o, i) => !o)
                    if (noOption.length > 0) {
                        hasOptionErrorError = true;
                        optionErrorNumbers.add(i + 1);
                    }
                }
                if (isStandardExam && !q.explanation) {
                    error.push({type:"display_name", questionIndex: i, message: `Question ${i + 1}: Explanation is required. `});
                }
                if (q.type === 'email' || q.type === 'essay' || q.type === 'multipleChoice' || q.type === 'trueFalse' || q.type === "multipleResponse" || q.type === 'audioTrueFalse') {
                    if (isQuestionEmpty(q.question)) {
                        questionErrorNumbers.add(i + 1);
                        hasQuestionError = true
                        questionErrorIndices.add(i);
                    }
                }
                if(q.type === 'audioEssay' || q.type === 'audioMultipleChoice'){
                    const groupQuestions = assignmentData.questions.filter(qp => qp.groupKey === q.groupKey);
                    if(groupQuestions.length > 1){
                        if(isQuestionEmpty(q.question)){
                            questionErrorNumbers.add(i + 1);
                            hasQuestionError = true
                            questionErrorIndices.add(i);
                        }
                    }
                }
                if (q.type === "audioToImage" || q.type === "audioEssay") {
                    if (isQuestionEmpty(q.question)) {
                        instructionErrorNumbers.add(i + 1);
                        hasInstructionError = true
                    }
                }
                if (q.type === "picture") {
                    if ((!q.pictures || q.pictures.length === 0 || q.pictures === "") && isQuestionEmpty(q.question)){
                        error.push({ type: 'display_name', questionIndex: i, message: `Question:${i+1} Atleast one of thing is required either question or picture`});
                    }
                  }
                  if(q?.type === 'match'){
                    const matchErrors = validateMatchMaking(q, i);
                     error.push(...matchErrors);
                  }
                    if(q.type === "photoCollage"){
                    if(q?.categoryType?.includes("Text") || q?.categoryType?.includes("Audio")){
                        if(q?.type_question_desc?.length === 0 || !q?.type_question_desc){
                            error.push({type:"display_name", questionIndex: i, message: `Question ${i + 1}: Collage Description is required`});
                        }
                      }
                    }
                   // Validation for "filling" question type
                   if (q.type === "filling" || q.type === "fillingImage") {
                     if (q.answerSelected && q.answerSelected?.length !== 0) {
                         q.answerSelected.forEach((x, qindex) => {
                             if (!x || x?.length < 2) {
                                 if(q.response_type === "dropdown"){
                                     error.push({ type: 'filling_error', message: `Fill in the blanks:${i + 1}.${qindex + 1} Atleast two options are required.` });
                                 }
                             }
                         })
                     }
                     if (q.type === "fillingImage" || q.fillingType === 'Audio' || q.fillingType === 'Image') {
                       q.filling_image.forEach((element, index) => {
                         if (index === 0 && (!element?.url || element?.url?.length === 0)) {
                           error.push({
                             type: "display_name",
                             questionIndex: i,
                             message: `Instruction: ${i + 1}.${index + 1} ${q.fillingType} is required.`,
                           });
                         }
                       });
                     }
                    if (isQuestionEmpty(q.question)){
                        error.push({ type: 'display_name', questionIndex: i, message: `Instruction:${i+1} Instruction is required.`});
                    }

                       if (q.options && q.options.length > 0) {
                           q.options.forEach((option, qindex) => {
                                if (!option || option.trim().length === 0) {
                                       error.push({
                                           type: 'display_name',
                                           questionIndex: i,
                                           message: `Question:${i + 1}.${qindex + 1}.  is required.`
                                       });
                                   }
                           });
                       }

                    if(q.answerSelected && q.answerSelected?.length !== 0 ){
                        q.answerSelected.forEach((x,index) => {
                            if (!x || x?.length === 0 || x.every(ans => !ans?.text || ans?.text?.length === 0)) {
                                error.push({ type: 'display_name', message: `Answer:${i+1}.${index+1} Atleast one answer is required.`});
                            }
                        })
                    } 
                    
                    if(q.highlightWords && q.highlightWords?.length > 0){
                        q.highlightWords.forEach((x,qindex) => {
                            let hasHighlightError = false;
                            if(!x || x?.length === 0){
                               error.push({ type: 'display_name', message: `Highlight-word:${i+1}.${qindex+1} Atleast one Highlight is required.`}); 
                               hasHighlightError = true;
                            }
                            if (!hasHighlightError && x) {
                                const hasEmptyText = x.some(hw => hw?.text === "" || hw?.text?.length === 0);
                                if (hasEmptyText) {
                                    error.push({ type: 'display_name', message: `Highlight-word:${i+1}.${qindex+1} Atleast one Highlight is required.`});
                                }
                            }
                        })
                    }  
                   }
                // Validation for "video" question type
                if (q.type === "video") {
                    if (isQuestionEmpty(q.question)) {
                        questionErrorNumbers.add(i + 1);
                        hasQuestionError = true;
                        questionErrorIndices.add(i);
                    }

                    // Validate video field
                    // if (!q.video || q.video.trim() === "") {
                    //     error.push({ type: 'video', message: `Question:${i + 1} Video field is required.` });
                    // }

                    // Validate duration field
                    if (!q.duration || typeof q.duration !== 'number' || q.duration <= 0) {
                        error.push({ type: 'video', questionIndex: i, message: `Question:${i + 1} Duration must be a positive number.` });
                    }
                }
                // Validation for Match Making question type
                // if (q.type === "match") {
                //     // Validate question field
                //     if (!q.question || q.question.trim() === "") {
                //         messageQ += `${i + 1},`;
                //         hasQuestionError = true;
                //     }
                // }
                if (q.type === 'audioToImage' || q.type === 'audioTrueFalse' || q.type === 'audioEssay') {
                    if (!q.audio) {
                        audioErrorNumbers.add(i + 1);
                        hasAudioError = true
                    }
                }
                if (q.type === 'audioMultipleChoice' && q.groupKey) {
                    const isFirstInGroup = assignmentData.questions.findIndex(
                        quest => quest.type === 'audioMultipleChoice' && quest.groupKey === q.groupKey
                    ) === i;
                    if (isFirstInGroup && !q.audio) {
                        audioErrorNumbers.add(i + 1);
                        hasAudioError = true
                    }
                }
                if(q.type === "audio" ){
                    if (isQuestionEmpty(q.question) && !q.audio) {
                         error.push({type:"display_name", questionIndex: i, message: `Question ${i + 1}: Either question text or audio file is required`});
                    }
                }
            })
            const messageQ = hasQuestionError ? `Question text required on q.no (${Array.from(questionErrorNumbers).sort((a, b) => a - b).join(', ')})` : '';
            const messageInstruction = hasInstructionError ? `Instruction text required on q.no (${Array.from(instructionErrorNumbers).sort((a, b) => a - b).join(', ')})` : '';
            const audioMessage = hasAudioError ? `Audio file required on (${Array.from(audioErrorNumbers).sort((a, b) => a - b).join(', ')})` : '';
            const optionMessage = hasOptionErrorError ? `Option text required on (${Array.from(optionErrorNumbers).sort((a, b) => a - b).join(', ')})` : '';
            let finalMessage = ``
            if (hasQuestionError) {
                finalMessage += messageQ + ".\n"
            }
            if (hasInstructionError) {
                finalMessage += messageInstruction + ".\n"
            }
            if (hasAudioError) {
                finalMessage += audioMessage + ".\n"
            }
            if (hasOptionErrorError) {
                finalMessage += optionMessage + ".\n"
            }
            if (finalMessage) {
                const allIndices = [...questionErrorIndices, ...optionErrorIndices, ...audioErrorIndices];
                error.push({
                    type: "question_error",
                    questionIndices: [...new Set(allIndices)],
                    message: finalMessage
                })
            }
        }
        setError(error)
        if (error.length == 0) {
            assignmentData.questions = assignmentData.questions.map(q => {
                if (q.type === 'essay') {
                    const arr = Array.isArray(q.expected_answer) ? q.expected_answer : [];
                    const filtered = arr.filter(ans => !isQuestionEmpty(ans));
                    return { ...q, expected_answer: filtered };
                }
                return q;
            });
            const ebookGradeLevels = getBookData?.grade_levels || [];
            const hasEbookStandards = Array.isArray(ebookGradeLevels) && ebookGradeLevels.length > 0;
            
            const questionsWithStandards = assignmentData.questions.filter(q => {
                if (!q.state_standard || !Array.isArray(q.state_standard) || q.state_standard.length === 0) {
                    return false;
                }
                return q.state_standard.some(stateStd => {
                    const standardArray = Array.isArray(stateStd?.standard) ? stateStd.standard : (stateStd?.standard ? [stateStd.standard] : []);
                    return standardArray.length > 0;
                });
            });
            
            const questionsWithoutStandards = assignmentData.questions.filter(q => {
                if (!q.state_standard || !Array.isArray(q.state_standard) || q.state_standard.length === 0) {
                    return true;
                }
                return !q.state_standard.some(stateStd => {
                    const standardArray = Array.isArray(stateStd?.standard) ? stateStd.standard : (stateStd?.standard ? [stateStd.standard] : []);
                    return standardArray.length > 0;
                });
            });
            
            // Call API when:
            // 1. Creating a new assignment (!isEditing): Always call if ebook has standards and there are questions without standards
            //    (even if ebook already has standards run, new questions still need standards assigned)
            // 2. Editing an assignment (isEditing): Only call if some questions have standards and some don't
            //    (mixed state - means new questions were added that need standards)
            const shouldCallAutoSelectAPI = hasEbookStandards && 
                questionsWithoutStandards.length > 0 && 
                (!isEditing || (isEditing && questionsWithStandards.length > 0));

                if (shouldCallAutoSelectAPI) {
                try {
                    setAlertLoading(true, 'Auto-selecting standards for questions...');
                    
                    const questionsWithoutStandardsIndices = assignmentData.questions
                        .map((q, index) => {
                            const hasStandards = q.state_standard && Array.isArray(q.state_standard) && q.state_standard.length > 0 && 
                                q.state_standard.some(stateStd => {
                                    const standardArray = Array.isArray(stateStd?.standard) ? stateStd.standard : (stateStd?.standard ? [stateStd.standard] : []);
                                    return standardArray.length > 0;
                                });
                            return hasStandards ? null : index;
                        })
                        .filter(index => index !== null);
                    
                    const questionsPayload = questionsWithoutStandardsIndices.map((originalIndex) => {
                        const q = assignmentData.questions[originalIndex];
                        return {
                            type: q.type,
                            id: q.id || originalIndex + 1,
                            expected_answer: q.expected_answer || [],
                            question: q.question || ""
                        };
                    });
                    
                    const result = await dispatch(handleAutoSelectStandardsForAllQuestions({
                        questions: questionsPayload,
                        bookId: String(bookId),
                        pageId: pageId ? parseInt(pageId) : null,
                        gradeLevels: ebookGradeLevels
                    }));
                    
                    if (result && Array.isArray(result) && result.length > 0) {
                        const updatedQuestions = cloneDeep(assignmentData.questions);
                        
                        result.forEach((item, resultIndex) => {
                            const originalQuestionIndex = questionsWithoutStandardsIndices[item.questionIndex !== undefined ? item.questionIndex : resultIndex];
                            if (originalQuestionIndex !== undefined && updatedQuestions[originalQuestionIndex]) {
                                if (item.state_standard && Array.isArray(item.state_standard)) {
                                    updatedQuestions[originalQuestionIndex].state_standard = item.state_standard;
                                } else if (item.standards && Array.isArray(item.standards) && item.standards.length > 0) {
                                    const validStandards = item.standards.filter((abbr) => {
                                        return find(standards, (st) => st.abbr === abbr) !== undefined;
                                    });
                                    
                                    if (validStandards.length > 0 && item.state && item.grade !== undefined) {
                                        updatedQuestions[originalQuestionIndex].state_standard = [{
                                            grade: item.grade,
                                            standard: validStandards,
                                            standard_name: item.state
                                        }];
                                    }
                                }
                            }
                        });
                        
                        assignmentData.questions = updatedQuestions;
                        setQuestions(updatedQuestions);
                        showAlert('Standards generated for this activity', 'success');
                    }
                    
                    setAlertLoading(false, '');
                } catch (apiError) {
                    setAlertLoading(false, '');
                    console.error('Error auto-selecting standards:', apiError);
                }
            }
            
            if (isEditing) {
                if (assignmentData.typeId === 'quiz' || assignmentData.typeId === 'quizresource') {
                    await dispatch(handleUpdateQuizzes(data.id, assignmentData))
                } else {
                    await dispatch(handleUpdateActivities(data.id, assignmentData))
                }
                logBookToolActivity('update', assignmentData.typeId, bookId, pageId, {
                    activityId: data.id,
                    bookName: getBookData?.name || 'Unknown Book',
                    displayName: assignmentData.displayName,
                    questionCount: assignmentData.questions?.length || 0,
                    type: assignmentData.type,
                    level: assignmentData.level,
                    isExam: assignmentData.is_exam,
                    isUnitExam: assignmentData.is_unit_exam
                });
            } else {
                if (assignmentData.typeId === 'quiz' || assignmentData.typeId === 'quizresource') {
                    await dispatch(handleCreateQuizzes(assignmentData))
                } else {
                    await dispatch(handleCreateActivities(assignmentData))
                }
                logBookToolActivity('create', assignmentData.typeId, bookId, pageId, {
                    bookName: getBookData?.name || 'Unknown Book',
                    displayName: assignmentData.displayName,
                    questionCount: assignmentData.questions?.length || 0,
                    type: assignmentData.type,
                    level: assignmentData.level,
                    isExam: assignmentData.is_exam,
                    isUnitExam: assignmentData.is_unit_exam
                });
            }
            await onDeleteDraft();
            if (onCreateOrUpdate) {
                onCreateOrUpdate()
            }
            setButtonDisabled(false);
            setLoading(false);
            onClose();
        }

        }catch(error){
            Sentry.captureException(`280 AssignmentForm onSubmit error: ${error}`);
            console.log(error);
        }finally{
            setLoading(false);
            setButtonDisabled(false);
        }
        
    };
    const onChangeEditType = () => {
        const normalizedQuestions = Array.isArray(data?.questions)
            ? data.questions
            : typeof data?.questions === 'string'
                ? (() => {
                    try {
                        const parsed = JSON.parse(data.questions || '[]');
                        return Array.isArray(parsed) ? parsed : [];
                    } catch (error) {
                        return [];
                    }
                })()
                : [];
        if (isEditing || draftId) {
            if (normalizedQuestions.length > 0) {
                const updatedQuestionsType = normalizedQuestions.map(question => {
                    const updatedQuestion = { ...question };
                    
                    if (question.type === 'email') {
                        updatedQuestion.type = 'essay';
                    }
                    if (question.type === 'twoMinAudio') {
                        updatedQuestion.type = 'audio';
                        updatedQuestion.duration = 120;
                    }
                    if (question.type === 'essay' && question.expected_answer && !Array.isArray(question.expected_answer)) {
                        updatedQuestion.expected_answer = [question.expected_answer];
                    }
                    if (question.type === 'essay' && !question.expected_answer) {
                        updatedQuestion.expected_answer = [''];
                    }
                    if (question.type === 'audioEssay' && !question.groupKey) {
                        updatedQuestion.groupKey = `essay-audio-${Math.random().toString(36).substring(2, 15)}`;
                    }
                    
                    if (question.state_standard && Array.isArray(question.state_standard)) {
                        updatedQuestion.state_standard = question.state_standard.map(stateStd => {
                            if (!stateStd) {
                                return {
                                    standard_name: '',
                                    grade: null,
                                    standard: []
                                };
                            }
                            if (typeof stateStd === 'string') {
                                return {
                                    standard_name: stateStd,
                                    grade: null,
                                    standard: []
                                };
                            }
                            return {
                                standard_name: stateStd?.standard_name || '',
                                grade: stateStd?.grade || null,
                                standard: Array.isArray(stateStd?.standard) ? stateStd.standard : (stateStd?.standard ? [stateStd.standard] : [])
                            };
                        }).filter(Boolean);
                    }
                    
                    return updatedQuestion;
                });
                return updatedQuestionsType;
            }
        }
        return [];
    };
    const handleInputChange = (index, optId, value) => {
        setInputValue((prev) => ({
            ...prev,
            [`${index}-${optId}`]: value, // Dynamically set the value for index and optId
        }));
    };
    
    const getInputValue = (index, optId) => {
        return inputValue[`${index}-${optId}`] || ""; // Get the value or default to an empty string
    };
    const onUpdateAnswer = (index, optId, value) => {
      try {
        const updatedQuestions = [...questions];

        // Ensure the question object exists at the given index
        if (!updatedQuestions[index]) {
          updatedQuestions[index] = {
            options: [],
            answerSelected: [],
          };
        }

        // Ensure the answer array exists
        if (!updatedQuestions[index].answerSelected) {
          updatedQuestions[index].answerSelected = [];
        }

        const combinedAnswers = [...new Set([...value])];

        updatedQuestions[index].answerSelected[optId] = combinedAnswers;

        // // on cancel click remove high lighted word
        if (updatedQuestions[index].highlightWords) {
          const highlightWordsData =
            updatedQuestions[index].highlightWords[optId];
          const filterHighlightedData = highlightWordsData?.filter((x) => {
            const isMatch = combinedAnswers?.some(
              (answer) => answer.text === x?.text
            );

            return isMatch;
          });
          updatedQuestions[index].highlightWords[optId] = filterHighlightedData;
        }
        // // Update the main questions state
        setQuestions(updatedQuestions);
      } catch (error) {
        Sentry.captureException(`281 AssignmentForm onUpdateAnswer error: ${error}`);
        console.log(error);
      }
    };

    const onDeleteOption = (index, optId) => {
      try {
        setError([]);
        const updatedQuestions = [...questions];
        const currentOptions = get(updatedQuestions, `[${index}].options`, []);
        const currentAnswers = get(
          updatedQuestions,
          `[${index}].answerSelected`,
          []
        );
        const currentHighlightedWords = get(
          updatedQuestions,
          `[${index}].highlightWords`,
          []
        );

        const currentMedia = get(updatedQuestions,`[${index}].filling_image`, []);

        // Remove the selected option and its corresponding answer
        updatedQuestions[index].options = currentOptions.filter(
          (_, i) => i !== optId
        );
        updatedQuestions[index].answerSelected = currentAnswers.filter(
          (_, i) => i !== optId
        );
        updatedQuestions[index].highlightWords = currentHighlightedWords.filter(
          (_, i) => i !== optId
        );
        updatedQuestions[index].filling_image = currentMedia.filter(
            (_, i) => i !== optId
        );

        // Update the state
        setQuestions(updatedQuestions);
      } catch (error) {
        Sentry.captureException(`282 AssignmentForm onDeleteOption error: ${error}`);
        console.log(error);
      }
    };

    const onDeleteMatchOption = (index, optId) => {
        const updatedQuestions = [...questions];
        const currentOptions = get(updatedQuestions, `[${index}].options`, []);
        // Remove the selected option and its corresponding answer
        updatedQuestions[index].options = currentOptions.filter((_, i) => i !== optId);
    
        // Update the state
        setQuestions(updatedQuestions);
    };
    
    useEffect(() => {
        if (data) {
            const currentDataId = data.id || data.docId || draftId;
            const wasInitialized = initializedDataIdRef.current !== null;
            const isSameActivity = initializedDataIdRef.current === currentDataId;
            
            if (wasInitialized && isSameActivity) {
                return;
            }
            
            const onChangeUpdateType = onChangeEditType();
            setQuestions(ensureQuestionUids(onChangeUpdateType || []))
            setcolorCode(get(data, "colorCode", ''))
            setIsExam(get(data, "is_exam", false));
            setIsUnitExam(get(data, "is_unit_exam", false))
            setStoryType(isStoryBook || get(data, "type") == 'story')
            setApExamType(isApExams || get(data, "type") == 'apexam')
            setExamCategories(get(data, "category", ''))
            setlevel(get(data, "level", ''))
            setUnit(get(data, "unit", ''))
            setUnitExam(get(data, "unit_exam", ''))
            setLanguageFeedback(get(data, "language_feedback", ''))
            setdisplayName(get(data, "displayName", ''))
            setAi_grading_config(get(data, "ai_grading_config", {}))
            setConfigAssignment(get(data, "config_assignment", {}))
            const pageSelectionFrom = get(data, "ai_grading_config.page_selection_from", null)
            const pageSelectionTo = get(data, "ai_grading_config.page_selection_to", null)
            const inferredPageLinkEnabled = pageSelectionFrom != null && pageSelectionTo != null
            const pageLinkEnabledFromField = get(data, "pageLinkConfiguration", false)
            const pageLinkEnabled = typeof pageLinkEnabledFromField === 'boolean' ? pageLinkEnabledFromField : inferredPageLinkEnabled
            setPageLinkConfiguration( pageSelectionFrom && pageSelectionTo ? true : false)
            const existingStandards = get(data, "standards", []) || get(data, "standard", []);
            setAssignmentStandards(Array.isArray(existingStandards) ? existingStandards : (existingStandards ? [existingStandards] : []))
            if(data.rubrics_id){
                setRubrics(data.rubrics_id)
            } else {
                setRubrics(null)
            }
            
            initializedDataIdRef.current = currentDataId;
            
            if (isEditing || data?.draft) {
                originalDataRef.current = {
                    displayName: get(data, "displayName", ''),
                    questions: onChangeUpdateType,
                    colorCode: get(data, "colorCode", ''),
                    level: get(data, "level", ''),
                    type: isStoryBook || get(data, "type") == 'story' ? 'story' : isApExams || get(data, "type") == 'apexam' ? 'apexam' : '',
                    category: get(data, "category", ''),
                    language_feedback: get(data, "language_feedback", ''),
                    is_exam: get(data, "is_exam", false),
                    is_unit_exam: get(data, "is_unit_exam", false),
                    unit: get(data, "unit", ''),
                    unit_exam: get(data, "unit_exam", ''),
                    ai_grading_config: get(data, "ai_grading_config", {}),
                    pageLinkConfiguration: pageLinkEnabled,
                    rubrics_id: data.rubrics_id || null
                };
            }
        } else {
            initializedDataIdRef.current = null;
        }
    }, [data, draftId, isEditing])
    const resolveQuestionIndex = (prevQuestions, indexOrQuestion) => {
        if (typeof indexOrQuestion === 'number') return indexOrQuestion;
        const uid = indexOrQuestion?._uid ?? indexOrQuestion;
        return prevQuestions.findIndex(q => q._uid === uid);
    };
    const onChangeQuestionData = useEffectEvent((val, key, indexOrQuestion) => {
        setQuestions(prevQuestions => {
            const i = resolveQuestionIndex(prevQuestions, indexOrQuestion);
            if (i === -1) return prevQuestions;
            const updatedQuestions = cloneDeep(prevQuestions);
            if (key === "expected_answer" && updatedQuestions[i].type === 'essay') {
                if (!Array.isArray(updatedQuestions[i].expected_answer)) {
                    updatedQuestions[i].expected_answer = updatedQuestions[i].expected_answer ? [updatedQuestions[i].expected_answer] : [''];
                }
            }
            const prevQuestionType = updatedQuestions[i].questionType;
            const prevMatchType = updatedQuestions[i].matchType;
            updatedQuestions[i][key] = val;
            if (key === "matchType" && prevMatchType !== val) {
                updatedQuestions[i].options = [{ item: "", match_item: "", match_audio: "" , match_text:'', questionImage:'', questionAudio:'' }];
            }
            if (key === "questionType" && prevQuestionType !== val) {
                updatedQuestions[i].options = [{ item: "", match_item: "", match_audio: "" , match_text:'', questionImage:'', questionAudio:'' }];
            }
              if(key === "collageLength"){
                updatedQuestions[i][key] = val;
                const validPhotoCollageData = photoCollageData.filter(item => item && item.id);
                const filteredFrames = validPhotoCollageData.slice(0, val);
                updatedQuestions[i]["collageFrame"] = filteredFrames;
            }
            if (key === "fillingType") {
                // updatedQuestions[i].options = [""];
                updatedQuestions[i].filling_image = [{ url: "" }];
                // updatedQuestions[i].answerSelected = [""];
            }
            return updatedQuestions;
        });
        setError([]);
    });
    
    const onChangeQuestionType = useEffectEvent((type, indexOrQuestion) => {
        setQuestions(prevQuestions => {
          const i = resolveQuestionIndex(prevQuestions, indexOrQuestion);
          if (i === -1) return prevQuestions;
          let v = cloneDeep(prevQuestions);
          const oldType = v[i].type;
          const oldGroupKey = v[i].groupKey;
          v[i].type = type;
          if(type!=="audioMultipleChoice" && type!=="audioEssay"){
            if (oldGroupKey && (oldType === 'audioMultipleChoice' || oldType === 'audioEssay')) {
              v = v.filter((q, idx) => idx === i || q.groupKey !== oldGroupKey);
            }
            delete v[i].groupKey;
            delete v[i].audio;
          }
    
          switch (type) {
            case 'multipleChoice':
              v[i].options = Array.isArray(v[i].options) && 
                            v[i].options.length === 4 && 
                            typeof v[i].options[0] !== "object"
                ? v[i].options
                : ['', '', '', ''];
              v[i].answer = !isNaN(parseInt(v[i].answer)) ? v[i].answer : 0;
              break;

            case 'multipleResponse':
              v[i].options = Array.isArray(v[i].options) && 
                            v[i].options.length === 4 && 
                            typeof v[i].options[0] !== "object"
                ? v[i].options
                : ['', '', '', ''];
              v[i].answer = Array.isArray(v[i].answer) ? v[i].answer : [];
              break;
    
            case 'trueFalse':
              v[i].options = ['Cierto', 'Falso'];
              v[i].answer = !isNaN(parseInt(v[i].answer)) ? v[i].answer : 0;
              break;
    
            case 'audio':
              v[i].duration = 60;
              delete v[i].options;
              delete v[i].answer;
              break;
            case 'audioEssay':
              v[i].duration = 60;
              v[i].audio = '';
              v[i].groupKey = `essay-audio-${Math.random().toString(36).substring(2, 15)}`;
              delete v[i].options;
              delete v[i].answer;
              break;
            case 'audioToImage':
              v[i].duration = 60;
              v[i].categoryType = "Image";
              v[i].studentCanUploadImages = v[i].studentCanUploadImages || 6;
              delete v[i].options;
              delete v[i].answer;
              break;
            case 'essay':
              if (!Array.isArray(v[i].expected_answer)) {
                v[i].expected_answer = v[i].expected_answer ? [v[i].expected_answer] : [];
              }
              if (!v[i].expected_answer || v[i].expected_answer.length === 0) {
                v[i].expected_answer = [];
              }
              break;
            case 'audioTrueFalse':
              v[i].duration = 60;
              v[i].options = ['Cierto', 'Falso'];
              v[i].answer = !isNaN(parseInt(v[i].answer)) ? v[i].answer : 0;
              break;
            case 'audioMultipleChoice':
              v[i].duration = 60;
              v[i].options = ['', '', '', ''];
              v[i].audio = '';
              v[i].answer = !isNaN(parseInt(v[i].answer)) ? v[i].answer : 0;
              v[i].groupKey = `multichoice-audio-${Math.random().toString(36).substring(2, 15)}`;
              break;
            case 'picture':
              v[i].categoryType = "Image";
              v[i].studentCanUploadImages = v[i].studentCanUploadImages || 6;
              v[i].additionalPictures = v[i].additionalPictures || [];
              delete v[i].options;
              delete v[i].answer;
              break;
    
            case 'video':
              v[i].duration = 60;
              delete v[i].options;
              delete v[i].answer;
              break;
    
            case 'match':
                v[i].matchType = "Text";
                v[i].questionType = "Text";
                v[i].options = [{ item: "", match_item: "", match_audio: ""  , match_text: "", questionImage:"", questionAudio:"" }];
              delete v[i].answer;
              break;
    
            case 'filling':
            case 'fillingImage':
              v[i].options = [""];
              v[i].fillingType = "None";
              v[i].response_type = "dropdown";
              v[i].answer = "";
              v[i].answerSelected = [""];
              v[i].highlightWords = [[{
                start: "",
                end: "",
                text: ""
              }]];
              v[i].selected_answer = [''];
              
            //   if (type === "fillingImage") {
                v[i].filling_image = [{
                  url: ""
                }];
            //   }
              break;
                case "photoCollage":
                // v[i].question = "";
                v[i].collageLength = 6;
                v[i].collageFrame = photoCollageData.slice(0, 6);
                v[i].categoryType =  [];
                break;
            default:
              break;
          }
    
          return v;
        });
    });

    
    const onchangeOption = useEffectEvent((index, optIndex, value, type) => {
        setQuestions(prevQuestions => {
            const updatedQuestions = cloneDeep(prevQuestions);
            if (!updatedQuestions[index].options) {
                updatedQuestions[index].options = [];
            }
            while (updatedQuestions[index].options.length <= optIndex) {
                updatedQuestions[index].options.push('');
            }
            updatedQuestions[index].options[optIndex] = value;
            if (type === 'trueFalse'|| type == 'audioTrueFalse') {
                updatedQuestions[index].options[optIndex] = value;
            }
            return updatedQuestions;
        });
    });
    const checkHighLightWithTyping = (updatedQuestions, index, optId, value) => {
      try {
        if (value?.trim()?.length > 0) {
          const highlightWords = updatedQuestions[index].highlightWords[optId];
          const optionText = value;

          const filterHighlightedWord = highlightWords?.filter((data) => {
            if (optionText?.includes(data?.text)) {
              return true;
            }
            return false;
          }) || [];
          updatedQuestions[index].highlightWords[optId] = filterHighlightedWord;

          if (updatedQuestions[index].answerSelected[optId]?.length > 0) {
            const customAnswerSelected =
              updatedQuestions[index].answerSelected[optId];
            const filterCustomAnswer =
              customAnswerSelected?.filter((data) => data.type === "custom") || [];

            const finalAnswerResult = [
              ...new Set([...filterCustomAnswer, ...filterHighlightedWord]),
            ];
            updatedQuestions[index].answerSelected[optId] = finalAnswerResult;
          }
        }
        return updatedQuestions;
      } catch (error) {
        Sentry.captureException(`283 AssignmentForm checkHighLightWithTyping error: ${error}`);
        console.log(error);
      }
    };


    const onchangeOptionFilling = useEffectEvent((index, optId, value) => {
      try {
        setQuestions(prevQuestions => {
          const updatedQuestions = [...prevQuestions];
          if (!updatedQuestions[index]) {
            updatedQuestions[index] = {
              options: [],
              answerSelected: [],
              highlightWords: [],
            };
          }

          if (!updatedQuestions[index].options) {
            updatedQuestions[index].options = [];
          }

          if (
            updatedQuestions[index].answerSelected &&
            value?.trim()?.length === 0
          ) {
            updatedQuestions[index].answerSelected[optId] = [];
            if (updatedQuestions[index].highlightWords) {
              updatedQuestions[index].highlightWords[optId] = [];
            }
          }
          updatedQuestions[index].options[optId] = value;

          if (!updatedQuestions[index].answerSelected) {
            updatedQuestions[index].answerSelected = [];
          }
          const filterUpdatedQuestion = checkHighLightWithTyping(
            updatedQuestions,
            index,
            optId,
            value
          );
          filterUpdatedQuestion[index].options[optId] = value || "";
          return filterUpdatedQuestion;
        });
      } catch (error) {
        Sentry.captureException(`284 AssignmentForm onchangeOptionFilling error: ${error}`);
        console.log(error);
      }
    });

    const handlePictureFilling = useEffectEvent((index, optId, value) => {
        setQuestions(prevQuestions => {
            const updatedQuestions = [...prevQuestions];
            if (!updatedQuestions[index].filling_image) {
                updatedQuestions[index].filling_image = [{
                    url: ""
                }];
            }
            updatedQuestions[index].filling_image[optId] = {url: value};
            return updatedQuestions;
        });
    }); 
    
    const onchangeOptionMatch = useEffectEvent((index, optIndex, value, type) => {
        setQuestions(prevQuestions => {
            const newQuestions = cloneDeep(prevQuestions);
            
            if (!newQuestions[index].options) {
                newQuestions[index].options = Array(4).fill('').map(() => ({}));
            }
    
            if (!newQuestions[index].options[optIndex]) {
                newQuestions[index].options[optIndex] = { item: "", match_item: "", match_audio: "" , match_text:'', questionImage:'', questionAudio:'' };
            }
    
            newQuestions[index].options[optIndex][type] = value;

            
            return newQuestions;
        });
    });
   
    
    const onChangeOptionsLength = useEffectEvent((index, length) => {
        setQuestions(prevQuestions => {
            const v = cloneDeep(prevQuestions)
            if (v[index].options) {
                let opt = v[index].options.slice(0, length)
                if (opt.length == length) {
                    v[index].options = opt;
                    if (v[index].type === 'multipleResponse') {
                        if (Array.isArray(v[index].answer)) {
                            v[index].answer = v[index].answer.filter(ans => parseInt(ans) < length);
                        }
                    } else if (v[index].answer >= opt.length) {
                        v[index].answer = 0;
                    }
                } else {
                    let len = length - opt.length;
                    let arr = new Array(len).fill('', 0, len)
                    opt.push(...arr)
                    v[index].options = opt;
                }
            } else {
                v[index].options = new Array(length).fill('')
                if (v[index].type === 'multipleResponse') {
                    v[index].answer = [];
                } else {
                    v[index].answer = 0;
                }
            }
            return v;
        });
    });
    const onAddOption = useEffectEvent((index) => {
      try {
        setQuestions(prevQuestions => {
          const updatedQuestions = cloneDeep(prevQuestions);

          if (!updatedQuestions[index].options) {
            updatedQuestions[index].options = [""];
          }
          if (!updatedQuestions[index].answerSelected) {
            updatedQuestions[index].answerSelected = [""];
          }
          if (!updatedQuestions[index].highlightWords) {
            updatedQuestions[index].highlightWords = [
              {
                start: "",
                end: "",
                text: "",
              },
            ];
          }

          if (!updatedQuestions[index].filling_image) {
              updatedQuestions[index].filling_image = [{ url: "" }];
          }

          updatedQuestions[index].options.push("");
          updatedQuestions[index].answerSelected.push("");
          updatedQuestions[index].highlightWords.push([
            {
              start: "",
              end: "",
              text: "",
            },
          ]);

          if (updatedQuestions[index].fillingType === "Image" || updatedQuestions[index].fillingType === "Audio") {
              updatedQuestions[index].filling_image.push([
                  {
                      url: "",
                  }
              ]);
          }
          return updatedQuestions;
        });
      } catch (error) {
        Sentry.captureException(`285 AssignmentForm onAddOption error: ${error}`);
        console.log(error);
      }
    });

    const onAddMatchOption = useEffectEvent((index) => {
        setQuestions((prevQuestions) => {
            const updatedQuestions = cloneDeep(prevQuestions);
            if (!updatedQuestions[index].options) {
                updatedQuestions[index].options = [];
            }
            updatedQuestions[index].options.push({ item: '', match_item: '', match_audio: '' , match_text:'', questionImage:'', questionAudio:'' });
            return updatedQuestions;
        });
    });


    const onAddExpectedAnswer = useEffectEvent((index) => {
        setQuestions((prevQuestions) => {
            const updatedQuestions = cloneDeep(prevQuestions);
            if (!Array.isArray(updatedQuestions[index].expected_answer)) {
                updatedQuestions[index].expected_answer = updatedQuestions[index].expected_answer ? [updatedQuestions[index].expected_answer] : [''];
            } else {
                updatedQuestions[index].expected_answer.push('');
            }
            return updatedQuestions;
        });
    });

    const onDeleteExpectedAnswer = useEffectEvent((index, answerIndex) => {
        setQuestions((prevQuestions) => {
            const updatedQuestions = cloneDeep(prevQuestions);
            if (Array.isArray(updatedQuestions[index].expected_answer)) {
                updatedQuestions[index].expected_answer = updatedQuestions[index].expected_answer.filter((_, i) => i !== answerIndex);
                if (updatedQuestions[index].expected_answer.length === 0) {
                    updatedQuestions[index].expected_answer = [];
                }
            }
            const questionNumber = index + 1;
            setError(prevErrors => {
                return prevErrors.filter(err => 
                    !(err.type === 'display_name' && err.message?.includes(`Question ${questionNumber}: Expected Response`))
                );
            });
            return updatedQuestions;
        });
    });

    const onChangeExpectedAnswer = useEffectEvent((index, answerIndex, value) => {
        setQuestions((prevQuestions) => {
            const updatedQuestions = cloneDeep(prevQuestions);
            if (!Array.isArray(updatedQuestions[index].expected_answer)) {
                updatedQuestions[index].expected_answer = updatedQuestions[index].expected_answer ? [updatedQuestions[index].expected_answer] : [''];
            }
            updatedQuestions[index].expected_answer[answerIndex] = value;
            const questionNumber = index + 1;
            if (!isQuestionEmpty(value)) {
                setError(prevErrors => {
                    return prevErrors.filter(err => 
                        !(err.type === 'display_name' && err.message?.includes(`Question ${questionNumber}: Expected Response`))
                    );
                });
            }
            return updatedQuestions;
        });
    });

    const onDeleteQuestion = useEffectEvent((indexOrQuestion) => {
        const i = typeof indexOrQuestion === 'number' ? indexOrQuestion : questions.findIndex(q => q._uid === (indexOrQuestion?._uid ?? indexOrQuestion));
        if (i === -1) return;
        const v = cloneDeep(questions)
        removeQuestionError(i, questions, setError)
        v.splice(i, 1)
        setQuestions(v)
    });
    const onAddQuestion = () => {
        const v = cloneDeep(questions)
        let _id = parseInt(get(v[v.length - 1], "id", 0))
        _id = isNaN(_id) ? 0 : _id + 1
        if (type == "quiz") {
            v.push({
                "options": [
                    "",
                    "",
                    "",
                    ""
                ],
                "id": _id,
                "question": "",
                "type": "multipleChoice",
                "answer": 0,
                "standard": "",
                _uid: `q-${Math.random().toString(36).slice(2)}`,
            })
            setQuestions(v)
        } else {
            v.push({
                "type": "essay",
                "id": _id,
                "expected_answer": [],
                _uid: `q-${Math.random().toString(36).slice(2)}`,
            })
        }

        setQuestions(v)
        if (innerRef.current) {
            setTimeout(() => {
                innerRef.current.scrollTo(0, innerRef.current.scrollHeight)
            }, 500)
        }
    }
    const onChangeAiConfig = useEffectEvent((configData) => {
         setAi_grading_config({...ai_grading_config,...configData})
    });

      const generateAIHandler = useEffectEvent(async ({ text, index, optId }) => {
        let hide;
        if (text?.length === 0 || !text)
          return showAlert(
         "Please provide option input","error"
          );
        try {
          setAlertLoading(true, 'Processing your request...');
          const updatedQuestions = [...questions];
          const response = await dispatch(
            handleGetAiOptionForAnswer({
              option_text: text,
            })
          );
          if (!response?.data) {
            showAlert("AI is not able to generate answer.","error");
            return;
          }
          if(!Array.isArray(response?.data[0])){
            showAlert("AI is not able to generate answer.","error");
            return;
        }
          if (!updatedQuestions[index].answerSelected) {
            updatedQuestions[index].answerSelected = [];
        }
          const data = updatedQuestions[index].answerSelected[optId];
          if(!data){
            updatedQuestions[index].answerSelected[optId] = [...new Set(response?.data[0])];
          }
          else{
            const mergedData = removeCustomDuplicates([...data, ...response?.data[0]]);
            updatedQuestions[index].answerSelected[optId] = [...new Set(mergedData)];
          }
        
          setQuestions(updatedQuestions);
        } catch (error) {
            Sentry.captureException(`286 AssignmentForm generateAIHandler error: ${error}`);
          console.log(error);
          showAlert("AI is not able to generate answer.","error");
        return;
        } finally {
          setAlertLoading(false, '');
        }
      });

          const toggleDropdown = (
            optId,
            isOpen,
            questionType,
            questionIndex
          ) => {
            setOptionStates((prev) => ({
              ...prev,
              [optId]: {
                ...prev[optId],
                questionIndex: questionIndex,
                type: questionType,
                dropdownOpen: isOpen,
              },
            }));
          };

          const toggleEditor = useEffectEvent((optId, isOpen, questionType, questionIndex) => {
            setOptionStates((prev) => ({
              ...prev,
              [optId]: {
                ...prev[optId],
                type: questionType,
                questionIndex: questionIndex,
                editorOpen: isOpen,
              },
            }));
          });

          const SelectAnswerDropDown = ({
            questionIndex,
            optId,
            optionText,
            questionType,
          }) => ({
            items: [
              {
                key: 'selectAnswer',
                label: (
                  <div onClick={() => toggleEditor(optId, true, questionType, questionIndex)}>
                    Select Answer from option
                  </div>
                )
              },
              {
                key: 'selectRandomAnswer',
                label: (
                  <div onClick={() => {
                    toggleEditor(optId, false, questionType, questionIndex);
                    generateAIHandler({
                      text: optionText,
                      index: questionIndex,
                      optId,
                    });
                  }}>
                    Select Random Answer with AI
                  </div>
                )
              }
            ]
          });





   const makeAnswerSubmitHandler = useEffectEvent((
          index,
          optId,
          highlightWords
        ) => {
          try {
            setQuestions(prevQuestions => {
              const updatedQuestions = [...prevQuestions];
              if (!updatedQuestions[index].answerSelected) {
                updatedQuestions[index].answerSelected = [];
              }
              if (!updatedQuestions[index].options) {
                updatedQuestions[index].options = [];
              }
              if (!updatedQuestions[index].highlightWords) {
                updatedQuestions[index].highlightWords = [];
              }
              updatedQuestions[index].highlightWords[optId] = highlightWords;
              const currentHighLightedWord =  updatedQuestions[index].highlightWords[optId];
              const currentAnswerSelected  = updatedQuestions[index].answerSelected[optId] || [];
              const filterAnswer = currentAnswerSelected?.filter(x => x.type === "custom") || [];
              const finalAnswer =[...filterAnswer,...currentHighLightedWord]; 
              const result = filterDuplicateWords(finalAnswer);
              updatedQuestions[index].answerSelected[optId] = [...new Set(result)];
              return updatedQuestions;
            });
          } catch (error) {
            Sentry.captureException(`287 AssignmentForm makeAnswerSubmitHandler error: ${error}`);
            console.log(error);
          }
        });

const renderGradePageRefAutocomplete = (question, index) => {
    const refIds = Array.isArray(question.grade_page_ref) ? question.grade_page_ref : []
    const selectedPages = refIds
        .map((id) => bookPages.find((p) => pageMatchesConfigId(p, id)))
        .filter(Boolean)
        .slice(0, 3)
    return (
        <FormControl variant="outlined" className={classes.formControl} fullWidth style={{ marginBottom: 16 }}>
            <Autocomplete
                multiple
                disableCloseOnSelect
                disabled={buttonDisabled}
                options={bookPages}
                value={selectedPages}
                onChange={(e, newValue) => {
                    const capped = newValue.slice(0, 3)
                    onChangeQuestionData(
                        capped.map((p) => p.pageId),
                        'grade_page_ref',
                        index
                    )
                }}
                getOptionLabel={(option) => pageDisplayLabel(option)}
                isOptionEqualToValue={(option, value) =>
                    Boolean(option && value && pageMatchesConfigId(option, value.pageId))
                }
                getOptionDisabled={(option) =>
                    selectedPages.length >= 3 &&
                    !selectedPages.some((s) => pageMatchesConfigId(s, option.pageId))
                }
                renderInput={(params) => (
                    <TextField
                        {...params}
                        label="Grade reference pages"
                        variant="outlined"
                        placeholder={
                            bookPages.length
                                ? 'Up to 3 pages'
                                : 'No pages loaded'
                        }
                        sx={{
                            '& .MuiOutlinedInput-root': { padding: '0px' },
                            '& .MuiOutlinedInput-input': { padding: '14px 14px' },
                        }}
                    />
                )}
            />
        </FormControl>
    )
}

const renderAudioWithMultiChoice = (question, index) => {
    if (renderedGroups.has(question.groupKey)) return null;
    renderedGroups.add(question.groupKey);
    const groupQuestions = questions.filter(q =>
        q.type === 'audioMultipleChoice' && q.groupKey === question.groupKey
    );
    return (
        <RelativeContainer key={question.groupKey}>
            <Row gutter={[24, 24]} style={{ justifyContent: "flex-end", display: "flex" }}>
                <IconButton onClick={() => { 
                        const groupKey = question.groupKey;
                         const indicesToRemove = questions
                             .map((q, idx) => q.groupKey === groupKey ? idx : -1)
                             .filter(idx => idx !== -1)
                             .sort((a, b) => b - a);
                         indicesToRemove.forEach(idx => {
                             removeQuestionError(idx, questions, setError);
                         });
                     setQuestions(prev => {
                        const newQuestions = [...prev].filter(k => k.groupKey != groupKey);
                        return newQuestions;
                    })
                 }} style={{ padding: 0, marginRight: 10 }}>
                    <Delete color="secondary" />
                </IconButton>
            </Row>
            <QuestionContainer key={question._uid ?? question.id} >
                <Detail index={index}>Question {index + 1} of {questions.length}</Detail>
                <Question style={{ marginTop: 16 }}>
                    <FormControl variant="outlined" className={classes.formControl}>
                        <InputLabel style={{ backgroundColor: 'white', paddingRight: 5 }} id="type">Question Type</InputLabel>
                        <Select
                            labelId="type"
                            id="type"
                            value={question.type}
                            required
                            onChange={(v) => {
                                onChangeQuestionType(v.target.value, question)
                            }}
                            label="Type"
                        >
                            {QUESTION_TYPE_ACTIVITY_NON_NATIVE?.map(v => (<MenuItem key={v.value} value={v.value}>{v.type}</MenuItem>))}
                        </Select>
                    </FormControl>
                </Question>
                {/* <Question style={{ marginTop: 6 }}>
                    <Acent inputRef={questionRefs.current[index]} setValue={v => onChangeQuestionData(v, "question", index)} style={{ marginBottom: 5, display: "flex", justifyContent: "flex-end" }} />
                    <TextField
                        id="question"
                        name="question"
                        label={(question?.type === 'filling' || question?.type === 'fillingImage' || question?.type === 'match') ? "Instruction" : "Question"}
                        InputLabelProps={{ shrink: true, required: true }}
                        type="text"
                        inputRef={ref => questionRefs.current[index] = ref}
                        required
                        variant="outlined"
                        onChange={e => {
                            onChangeQuestionData(e.target.value, "question", index)
                        }}
                        value={question.question}
                    />
                </Question> */}
                <Question style={{ marginTop: 6 }}>
                    <AudioMultipleChoice
                        groupKey={question.groupKey}
                        index={index}
                        questions={groupQuestions}
                        setButtonDisabled={setButtonDisabled}
                        setQuestions={(newGroup) => {
                            setQuestions(prev => {
                                const groupKey = newGroup[0].groupKey;
                                const startIndex = prev.findIndex(q => q.groupKey === groupKey);
                                const endIndex = (() => {
                                    const reversedIndex = [...prev].reverse().findIndex(q => q.groupKey === groupKey);
                                    return reversedIndex === -1 ? startIndex : prev.length - reversedIndex;
                                })();
                                if (startIndex === -1) return prev;
                                const newQuestions = [...prev];
                                newQuestions.splice(startIndex, endIndex - startIndex, ...newGroup);
                                return newQuestions;
                            });
                        }}
                    />
                </Question>
                <Question style={{ marginTop: 16 }} className="floatingLabelBG">
                    {renderGradePageRefAutocomplete(question, index)}
                    <TextField
                        label="Grade Prompt"
                        variant="outlined"
                        fullWidth
                        multiline
                        rows={2}
                        InputLabelProps={{ shrink: true }}
                        onChange={(e) => {
                            onChangeQuestionData(e.target.value, "grade_prompt", index);
                        }}
                        value={question.grade_prompt || ""}
                        placeholder="Optional prompt for AI grading..."
                        disabled={buttonDisabled}
                    />
                </Question>
            </QuestionContainer>
        </RelativeContainer>
    );
}

const renderAudioWithWrittenResponse = (question, index) => {
    if (question.groupKey && essayGroupKey.has(question.groupKey)) return null;
    essayGroupKey.add(question.groupKey);
    const groupQuestions = questions.filter(q =>
        q.type === 'audioEssay' && q.groupKey === question.groupKey && question.groupKey
    );
    return (
        <RelativeContainer key={question.groupKey}>
            <Row gutter={[24, 24]} style={{ justifyContent: "flex-end", display: "flex" }}>
                <IconButton onClick={() => {
                    setQuestions(prev => {
                        const groupKey = question.groupKey;
                        const newQuestions = [...prev].filter(k => k.groupKey != groupKey);
                        return newQuestions;
                    })
                }} style={{ padding: 0, marginRight: 10 }}>
                    <Delete color="secondary" />
                </IconButton>
            </Row>
            <QuestionContainer key={question._uid ?? question.id} >
                <Detail index={index}>Question {index + 1} of {questions.length}</Detail>
                <Question style={{ marginTop: 16 }}>
                    <FormControl variant="outlined" className={classes.formControl}>
                        <InputLabel style={{ backgroundColor: 'white', paddingRight: 5 }} id="type">Question Type</InputLabel>
                        <Select
                            labelId="type"
                            id="type"
                            value={question.type}
                            required
                            onChange={(v) => {
                                onChangeQuestionType(v.target.value, question)
                            }}
                            label="Type"
                        >
                            {QUESTION_TYPE_ACTIVITY_NON_NATIVE?.map(v => (<MenuItem key={v.value} value={v.value}>{v.type}</MenuItem>))}
                        </Select>
                    </FormControl>
                </Question>
                <Question style={{ marginTop: 6 }}>
                    <AudioWithEssay
                        groupKey={question.groupKey}
                        index={index}
                        questions={groupQuestions}
                        setButtonDisabled={setButtonDisabled}
                        setQuestions={(newGroup) => {
                           setQuestions(prev => {
                               const groupKey = newGroup[0].groupKey;
                               const startIndex = prev.findIndex(q => q.groupKey === groupKey);
                               const endIndex = (() => {
                                   const reversedIndex = [...prev].reverse().findIndex(q => q.groupKey === groupKey);
                                   return reversedIndex === -1 ? startIndex : prev.length - reversedIndex;
                               })();
                               if (startIndex === -1) return prev;
                               const newQuestions = [...prev];
                               newQuestions.splice(startIndex, endIndex - startIndex, ...newGroup);
                               return newQuestions;
                           });
                        }}
                    />
                </Question>
                <Question style={{ marginTop: 16 }} className="floatingLabelBG">
                    {renderGradePageRefAutocomplete(question, index)}
                    <TextField
                        label="Grade Prompt"
                        variant="outlined"
                        fullWidth
                        multiline
                        rows={2}
                        InputLabelProps={{ shrink: true }}
                        onChange={(e) => {
                            onChangeQuestionData(e.target.value, "grade_prompt", index);
                        }}
                        value={question.grade_prompt || ""}
                        placeholder="Optional prompt for AI grading..."
                        disabled={buttonDisabled}
                    />
                </Question>
            </QuestionContainer>
        </RelativeContainer>
    );
}

const onDraftDelete = async () => {
    if (!draftId) return;
    try {
        const docRef = doc(firestore, import.meta.env.VITE_APP_STAGE?.trim() === 'prod' ? 'draft_activity_prod' : 'draft_activity', draftId);
        await deleteDoc(docRef);
        setDraftId(null);
    } catch (error) {
        console.error('error', error);
        Sentry.captureException(error);
    }
}

useEffect(() => {
    if (!open) return;
    if (!draftId) return;
    if (!isEditing) return;
    if (openedFromDraftCard) return;
    if (!originalDataRef.current) return;
    if (hasDataChanged()) return;
    onDraftDelete();
}, [open, draftId, isEditing, openedFromDraftCard]);

const hasDataChanged = useEffectEvent(() => {
    if ((!isEditing && !data?.draft) || !originalDataRef.current) return false;

    const normalizeQuestions = (items = []) =>
        (items || []).map((item) => {
            const { _uid, ...rest } = item || {};
            return rest;
        });
    const stableStringify = (value) => {
        try {
            const seen = new WeakSet();
            const sorter = (val) => {
                if (val === null || typeof val !== 'object') return val;
                if (val instanceof Date) return val.toISOString();
                if (Array.isArray(val)) return val.map(sorter);
                if (seen.has(val)) return undefined;
                seen.add(val);
                const keys = Object.keys(val).sort();
                const out = {};
                keys.forEach((k) => {
                    const v = sorter(val[k]);
                    if (v !== undefined) out[k] = v;
                });
                return out;
            };
            return JSON.stringify(sorter(value));
        } catch (e) {
            return JSON.stringify(value);
        }
    };
    const currentData = {
        displayName: displayName,
        questions: normalizeQuestions(questions),
        colorCode: colorCode,
        level: level,
        type: storyType ? 'story' : apExamType ? 'apexam' : '',
        category: examCategories,
        language_feedback: languageFeedback,
        is_exam,
        is_unit_exam: isUnitExam,
        unit: isUnitExam ? unit : '',
        unit_exam: isUnitExam ? unit_exam : '',
        ai_grading_config: getAiGradingConfigForPayload(ai_grading_config, pageLinkConfiguration),
        pageLinkConfiguration,
        rubrics_id: rubrics
    };
    
    const original = originalDataRef.current;
    const originalQuestions = normalizeQuestions(original.questions);
    const originalAiPayload = getAiGradingConfigForPayload(original.ai_grading_config, original.pageLinkConfiguration);
    const diff = {
        displayName: currentData.displayName !== original.displayName,
        questions: JSON.stringify(currentData.questions) !== JSON.stringify(originalQuestions),
        colorCode: currentData.colorCode !== original.colorCode,
        level: currentData.level !== original.level,
        type: currentData.type !== original.type,
        category: stableStringify(currentData.category) !== stableStringify(original.category),
        language_feedback: currentData.language_feedback !== original.language_feedback,
        is_exam: currentData.is_exam !== original.is_exam,
        is_unit_exam: currentData.is_unit_exam !== original.is_unit_exam,
        ai_grading_config: JSON.stringify(currentData.ai_grading_config) !== JSON.stringify(originalAiPayload),
        pageLinkConfiguration: stableStringify(currentData.pageLinkConfiguration) !== stableStringify(original.pageLinkConfiguration),
        rubrics_id: stableStringify(currentData.rubrics_id) !== stableStringify(original.rubrics_id),
    };
    const changed = Object.values(diff).some(Boolean);
    return changed;
})

const closeDrawer = async () => {
    try{
        if (skipDeleteAfterDraftSaveRef.current) {
            skipDeleteAfterDraftSaveRef.current = false;
            onClose();
            return;
        }
        if(buttonDisabled){
            showAlert("Please wait until the process is complete", "error");
            return;
        }
    
        const assignmentData = {
            ...data,
            chapter: bookId,
            bookId: bookId,
            displayName: displayName,
            page: pageId,
            typeId: assignmentType ? assignmentType : "activity",
            questions: (questions || []).map(({ _uid, ...q }) => q),
            colorCode: colorCode,
            level: level,
            type: storyType ? 'story' : apExamType ? 'apexam' : '',
            category: examCategories,
            language_feedback: languageFeedback,
            is_exam,
            is_unit_exam: isUnitExam,
            unit: isUnitExam ? unit : '',
            unit_exam: isUnitExam ? unit_exam : '',
            ai_grading_config: getAiGradingConfigForPayload(ai_grading_config, pageLinkConfiguration),
            pageLinkConfiguration,
            rubrics_id: rubrics,
            standards: assignmentStandards && assignmentStandards.length > 0 ? assignmentStandards : []
        }
        const isEmptyCheck = (assignmentData?.displayName?.length === 0 && assignmentData?.questions?.length === 0 && !assignmentData?.language_feedback);
        const isPersistedDraftInList = Boolean(openedFromDraftCard);
        const isEditingNoChanges = isEditing && !hasDataChanged();
        const shouldDeleteTempDraft = Boolean(draftId && isEditing && !isPersistedDraftInList); 
        const hasDraftData = assignmentDraftHasUserContent({ displayName, questions });
        if (isEditingNoChanges || isEmptyCheck || !hasDraftData) {
            if (shouldDeleteTempDraft || isEmptyCheck || !hasDraftData) {
                await onDraftDelete();
            }
            onClose();
            return;
        }

        if (draftId) {
            if (!hasDraftData) {
                if (shouldDeleteTempDraft) {
                    await onDraftDelete();
                }
                onClose();
                return;
            }

            if ((isEditing || isPersistedDraftInList) && originalDataRef.current && !hasDataChanged()) {
                onClose();
                return;
            }

            Modal.confirm({
                title: 'Draft Assignment',
                content: 'This is not created yet, this is still in draft. Do you still want to close?',
                okText: 'Close',
                cancelText: 'Cancel',
                okButtonProps: {
                    className: 'force-blue-button',
                    style: {
                        backgroundColor: '#012B70',
                        borderColor: '#012B70',
                    }
                },
                onOk: () => {
                    return new Promise(async (resolve) => {
                        try {
                            setAlertLoading(true, 'Closing...');
                            saveDraftRef.current?.cancel?.();
                            const draftData = prepareDraftData();
                            if (!assignmentDraftHasUserContent(draftData)) {
                                await onDraftDelete();
                                onClose();
                                return;
                            }
                            await createDraftActivity(draftId, draftData);
                            const savedDraft = {
                                docId: draftId,
                                ...draftData,
                                questions: Array.isArray(draftData.questions) ? draftData.questions : (typeof draftData.questions === 'string' ? JSON.parse(draftData.questions || '[]') : []),
                                draft: true
                            };
                            skipDeleteAfterDraftSaveRef.current = true;
                            onClose(savedDraft);
                        } catch (err) {
                            console.error('Error saving draft on close:', err);
                            onClose();
                        } finally {
                            setAlertLoading(false, '');
                            resolve();
                        }
                    });
                },
                onCancel: () => {

                },
            });
        } else if (isEditing && hasDataChanged()) {
            Modal.confirm({
                title: 'Unsaved Changes',
                content: 'You have unsaved changes. Do you want to close without saving?',
                okText: 'Close',
                cancelText: 'Cancel',
                okButtonProps: {
                    className: 'force-blue-button',
                    style: {
                        backgroundColor: '#012B70',
                        borderColor: '#012B70',
                    }
                },
                onOk: () => {
                    onClose();
                },
                onCancel: () => {

                },
            });
        } else {
            onClose();
        }
    }catch(error){
        console.error('error', error);
        Sentry.captureException(error);
    }
}

useEffect(() => {
    if(questions?.length === 0) {
        setError([]);
    }
 },[questions])

 const showInstructionLabel = useCallback((question) => {
    if(question.type === 'filling' || question.type === 'fillingImage' || question.type === 'match' || question.type === 'audioToImage' || question.type === 'audioEssay' || question.type === 'audioTrueFalse'){
        return "Instruction*";
    }
    return "Question*";
 }, [questions]);

 const renderLabel = (value) => {
    if (!value) return value;
    
    const stateName = getStateNameDisplayForCode(value);
    if (stateName) {
        return stateName;
    }
    
    return value;
 }

 const handleStateStandardChange = (selectedValues, questionIndex, stateIndex, standardObj) => {
    setQuestions(prevQuestions => {
        const updatedQuestions = cloneDeep(prevQuestions);
        if (!updatedQuestions[questionIndex].state_standard) {
            updatedQuestions[questionIndex].state_standard = [];
        }
        if (!Array.isArray(updatedQuestions[questionIndex].state_standard)) {
            updatedQuestions[questionIndex].state_standard = [];
        }
        
        const targetStateName = standardObj?.standard_name || '';
        const existingIndex = updatedQuestions[questionIndex].state_standard.findIndex(s => {
            const sState = typeof s === 'string' ? s : get(s, 'standard_name', '');
            return statesMatch(sState, targetStateName);
        });
        
        if (existingIndex >= 0) {
            updatedQuestions[questionIndex].state_standard[existingIndex] = {
                ...updatedQuestions[questionIndex].state_standard[existingIndex],
                standard_name: targetStateName,
                grade: standardObj?.grade || updatedQuestions[questionIndex].state_standard[existingIndex]?.grade || null,
                standard: Array.isArray(selectedValues) ? selectedValues : (typeof selectedValues === 'string' && selectedValues ? selectedValues.split(',').map(s => s.trim()).filter(s => s) : [])
            };
        } else {
            const newStateStandard = {
                standard_name: targetStateName,
                grade: standardObj?.grade || null,
                standard: Array.isArray(selectedValues) ? selectedValues : (typeof selectedValues === 'string' && selectedValues ? selectedValues.split(',').map(s => s.trim()).filter(s => s) : [])
            };
            updatedQuestions[questionIndex].state_standard.push(newStateStandard);
        }
        
        return updatedQuestions;
    });
};
    return (
        <SentryWrap>
        <Drawer
                height="100%"
                onClose={closeDrawer}
                placement="top"
                open={open}
                key="quizNew"
                className="assignments-drawer"
                keyboard={false}
                destroyOnHidden
            >
         <Wrapper>
           
            <Row className="editQuizUpr">
                <Col xs={24} sm={12} md={12} style={{ padding: "16px 10px" }}>
                    <ImageContiner>
                        <Image src={pageSrc} alt='' />
                    </ImageContiner>
                </Col>
                <Col xs={24} sm={12} md={12} style={{ padding: "16px 16px" }}>
                    <Header>{isEditing ? `Edit ${assignmentType}` : `Create ${assignmentType}`}</Header>
                    <Row justify="start" style={{ marginBottom: 10, alignItems:"flex-end" }} gutter={[15, 15]}>
                        <Col span={16}>
                        <Acent inputRef={dispNameRef} setValue={setdisplayName}  style={{ marginBottom: 5 , display:"flex" ,justifyContent:"flex-end" }}  />
                            <TextField
                                id="displayName"
                                name="displayName"
                                label="Display Name"
                                InputLabelProps={{ shrink: true, required: true }}
                                type="text"
                                required
                                inputRef={dispNameRef}
                                variant="outlined"
                                onChange={e => {
                                    setdisplayName(e.target.value)
                                }}
                                value={displayName}
                            />
                        </Col>
                        <Col span={8} className='floatingLabelBG'>
                            <FormControl variant="outlined" className={classes.formControl}>
                                <InputLabel id="type">Level</InputLabel>
                                <Select
                                    labelId="level"
                                    id="level"
                                    required={false}
                                    value={level || ''}
                                    onChange={(v) => {
                                        setlevel(v.target.value)
                                    }}
                                    label="Type"
                                >
                                    <MenuItem value={'BASICO'}>BASICO</MenuItem>
                                    <MenuItem value={'INTERMEDIO'}>INTERMEDIO</MenuItem>
                                    <MenuItem value={'AVANZADO'}>AVANZADO</MenuItem>
                                </Select>
                            </FormControl>
                        </Col>
                    </Row>
                    <Row justify="start" style={{ marginBottom: 20, marginTop: 20 }}>
                        <Col span={12} style={{ paddingLeft: 16 }}>
                            {isStoryBook && <FormControlLabel
                                classes={{
                                    root: classes.rootDifFull,
                                    label: classes.label,
                                }}
                                control={
                                    <Switch
                                        classes={{
                                            sizeSmall: classes.sizeSmall,
                                            checked: classes.checkedSwitch
                                        }}
                                        checked={storyType}
                                        id="type_story"
                                        onChange={e => {
                                            setStoryType(e.target.checked)
                                        }}
                                        name="type_story"
                                        color="primary"
                                        size="small"
                                    />
                                }
                                label="Assignment for Story"
                            />}
                            {isApExams && <FormControlLabel
                                classes={{
                                    root: classes.rootDifFull,
                                    label: classes.label,
                                }}
                                control={
                                    <Switch
                                        classes={{
                                            sizeSmall: classes.sizeSmall,
                                            checked: classes.checkedSwitch
                                        }}
                                        checked={apExamType}
                                        id="type_story"
                                        onChange={e => {
                                            setApExamType(e.target.checked)
                                        }}
                                        name="type_story"
                                        color="primary"
                                        size="small"
                                    />
                                }
                                label="Assignment for AP"
                            />}
                        </Col>
                    </Row>
                    <Row justify="start" style={{ marginBottom: 20, marginTop: 20 }}>
                        <Col span={12} xs={24} lg={12} className='floatingLabelBG'>
                            <FormControl variant="outlined" className={classes.formControl}>
                                <InputLabel id="type">Language for AI Feedback</InputLabel>
                                <Select
                                    labelId="language_feedback"
                                    id="language_feedback"
                                    required={false}
                                    value={languageFeedback || ''}
                                    onChange={(v) => {
                                        setLanguageFeedback(v.target.value)
                                    }}
                                    label="Type"
                                >
                                    <MenuItem value={'ENGLISH'}>English</MenuItem>
                                    <MenuItem value={'SPANISH'}>Spanish</MenuItem>
                                </Select>
                            </FormControl>
                        </Col>
                        {showStandardsField && (
                            <Col span={12} xs={24} lg={12} style={{ paddingLeft:12}} className='floatingLabelBG'>
                                <FormControl variant="outlined" className={classes.formControl} fullWidth>
                                    <InputLabel id="standards">Standards</InputLabel>
                                    <Select
                                        labelId="standards"
                                        id="standards"
                                        multiple
                                        value={assignmentStandards || []}
                                        onChange={(e) => {
                                            setAssignmentStandards(e.target.value)
                                        }}
                                        label="Standards"
                                        renderValue={(selected) => {
                                            if (!selected || selected.length === 0) return '';
                                            return selected.length === 1 ? selected[0] : `${selected.length} standards selected`;
                                        }}
                                    >
                                        {assignmentStandardsOptions.map((option) => (
                                            <MenuItem key={option.value} value={option.value}>
                                                {option.label}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Col>
                        )}
                        <Col span={12} style={{ paddingLeft:12}} className='floatingLabelBG'>
                            <FormControlLabel
                                classes={{
                                    root: classes.rootDifFull,
                                    label: classes.label,
                                }}
                                control={
                                    <Switch
                                        classes={{
                                            sizeSmall: classes.sizeSmall,
                                            checked: classes.checkedSwitch
                                        }}
                                        checked={is_exam}
                                        id="is_exam"
                                        onChange={e => {
                                            if (isUnitExam) {
                                                setIsExam(e.target.checked)
                                                setIsUnitExam(false)
                                                setUnit(null);
                                                setUnitExam(null);
                                            } else {
                                                setIsExam(e.target.checked)
                                            }
                                        }}
                                        name="is_exam"
                                        color="primary"
                                        size="small"
                                    />
                                }
                                label="Mark as Quiz"
                            />
                        </Col>
                    </Row>
                    <Row justify="start" style={{ marginBottom: 20, marginTop: 20 }}>
                        <Col span={8} style={{ paddingLeft: 12, display: 'flex', justifyContent: 'center' }} className='floatingLabelBG'>
                            <FormControlLabel
                                classes={{
                                    root: classes.rootDifFull,
                                    label: classes.label,
                                }}
                                disabled={!filteredUnits?.id || orderedBook?.length === 0}
                                control={
                                    <Switch
                                        classes={{
                                            sizeSmall: classes.sizeSmall,
                                            checked: classes.checkedSwitch
                                        }}
                                        checked={isUnitExam}
                                        id="is_unit_exam"
                                        onChange={e => {
                                            const checked = e.target.checked;
                                            if (is_exam) {
                                                setIsUnitExam(checked);
                                                setIsExam(false);
                                            } else {
                                                setIsUnitExam(checked);
                                                if (!checked) {
                                                    setUnit(false);
                                                    setUnitExam(false);
                                                }
                                            }
                                        }}
                                        name="is_unit_exam"
                                        color="primary"
                                        size="small"
                                    />
                                }
                                label="Mark as Unit Exam"
                            />
                        </Col>
                        {isUnitExam && (
                            <>
                                <Col span={4} className='floatingLabelBG' style={{ padding: '0 8px', display: 'flex', alignItems: 'center' }}>
                                   <span>{`${getBookData?.description} - ${getBookData?.id}`}</span>
                                </Col>
                                <Col span={6} className='floatingLabelBG' style={{ padding: '0 8px' }}>
                                    <FormControl variant="outlined" className={classes.formControl} style={{ minWidth: 120 }}>
                                        <InputLabel id="type">Unit</InputLabel>
                                        <Select
                                            labelId="unit"
                                            id="unit"
                                            required={false}
                                            value={unit || ''}
                                            onChange={(v) => {
                                                setUnit(v.target.value)
                                            }}
                                            label="Type"
                                            disabled
                                        >
                                            <MenuItem value={filteredUnits?.shortName}>{filteredUnits?.shortName}</MenuItem>
                                        </Select>
                                    </FormControl>
                                </Col>
                                <Col span={6} className='floatingLabelBG' style={{ padding: '0 8px' }}>
                                    <FormControl variant="outlined" className={classes.formControl} style={{ minWidth: 120 }}>
                                        <InputLabel id="type">Unit Exam</InputLabel>
                                        <Select
                                            labelId="unit_exam"
                                            id="unit_exam"
                                            required={false}
                                            value={unit_exam || ''}
                                            onChange={(v) => {
                                                setUnitExam(v.target.value)
                                            }}
                                            label="Type"
                                            disabled
                                        >
                                            <MenuItem value={filteredActivities + 1}>{`Unit Exam ${filteredActivities + 1}`}</MenuItem>
                                        </Select>
                                    </FormControl>
                                </Col>
                            </>
                        )}
                    </Row>
                    {isApExams && <Row justify="start" style={{ marginBottom: 20, marginTop: 20 }}>
                        <Question style={{ marginTop: 16 }}>
                            <FormControl variant="outlined" className={classes.formControl} style={{ minWidth: 250 }} >
                                <InputLabel id="type" style={{ backgroundColor: "#fff" }}>Category for {isApExams ? 'AP Exams' : 'Exams'}</InputLabel>
                                <Select
                                    labelId="category"
                                    id="category"
                                    value={examCategories}
                                    required
                                    onChange={(e) => {
                                        setExamCategories(e.target.value)
                                        setError(prev => prev.filter(k => k.type != 'category_ap'))
                                    }}
                                    label={`Category for ${isApExams ? 'AP Exams' : 'Exams'}`}
                                >
                                    {EXAM_LABELS_FULL.map(v => (<MenuItem value={v} key={v}>{v}</MenuItem>))}
                                </Select>
                                <FormHelperText error >{find(errors, ['type', 'category_ap'])?.message}</FormHelperText>
                            </FormControl>
                        </Question>
                    </Row>}
                    {checkExamBookType && 
                        <Row justify="start" style={{ marginBottom: 20, marginTop: 20 }}>
                        <Question style={{ marginTop: 16 }}>
                            <FormControl variant="outlined" className={classes.formControl} style={{ minWidth: 250 }} >
                                <InputLabel id="type" style={{ backgroundColor: "#fff" }}>Category for Exams</InputLabel>
                                <Select
                                    labelId="category"
                                    id="category"
                                    value={examCategories}
                                    required
                                    onChange={(e) => {
                                        setExamCategories(e.target.value)
                                        setError(prev => prev.filter(k => k.type != 'category_ap'))
                                    }}
                                    label={`Category for Exams`}
                                >
                                    {EXAM_TYPE_LABEL.map(v => (<MenuItem value={v} key={v}>{v}</MenuItem>))}
                                </Select>
                                <FormHelperText error >{find(errors, ['type', 'category_ap'])?.message}</FormHelperText>
                            </FormControl>
                        </Question>
                    </Row>
                    }
                    <Row style={{ justifyContent: "space-between", marginBottom: 16 }}>
                    <ModalMenu
                        type={"selectRubricModal"}
                        addedRubric={selectedRubricData}
                        setAddedRubric={(val) => {
                            setRubrics(val?.id)
                        }}
                        resetConfig={() => {
                            setRubrics(null)
                        }}
                    />
                    </Row>
                    <AiConfiguration config={ai_grading_config} onChangeConfig={onChangeAiConfig} pages={getBookData?.pages || []}/>
                    {!isVideoAvailable && configEngageMent?.isFrom !== 'engagement' && (
                        <Col span={12} style={{ marginBottom: 12 }} className='floatingLabelBG'>
                            <FormControlLabel
                                classes={{
                                    root: classes.rootDifFull,
                                    label: classes.label,
                                }}
                                label="Read Lesson Configuration"
                                control={
                                    <Switch
                                        classes={{
                                            sizeSmall: classes.sizeSmall,
                                            checked: classes.checkedSwitch
                                        }}
                                        checked={pageLinkConfiguration}
                                        id="pageLinkConfiguration"
                                        onChange={e => {
                                            setPageLinkConfiguration(e.target.checked)
                                        }}
                                        name="pageLinkConfiguration"
                                        color="primary"
                                        size="small"
                                    />
                                }
                            />
                        </Col>
                    )}
                    {!isVideoAvailable && pageLinkConfiguration && (
                        <AiconfigWrapper style={{ marginTop: 16 }}>
                            <AiConfigArea>Read Lesson Configuration</AiConfigArea>
                            <Row gutter={[16, 16]} style={{ marginTop: 16 }}>
                                <Col span={12}>
                                    <FormControl variant="outlined" className={classes.formControl} fullWidth>
                                        <InputLabel id="page-selection-from">From</InputLabel>
                                        <Select
                                            labelId="page-selection-from"
                                            id="page-selection-from"
                                            value={resolveReadLessonPageValue(ai_grading_config.page_selection_from)}
                                            onChange={(e) => {
                                                const newFrom = e.target.value;
                                                const nfi = readLessonPageIdToIndex.get(parseInt(newFrom, 10)) ?? 0;
                                                const currentToPid = resolveReadLessonPageValue(ai_grading_config.page_selection_to);
                                                const currentToIdx = readLessonPageIdToIndex.get(currentToPid) ?? 0;
                                                onChangeAiConfig({
                                                    page_selection_from: newFrom,
                                                    ...(currentToIdx < nfi && { page_selection_to: newFrom })
                                                });
                                            }}
                                            label="From"
                                        >
                                            {readLessonPagePool.map((page) => (
                                                <MenuItem key={page.pageId} value={parseInt(page.pageId, 10)}>{page.NumberMasked || `Page ${page.pageId}`}</MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </Col>
                                <Col span={12}>
                                    <FormControl variant="outlined" className={classes.formControl} fullWidth>
                                        <InputLabel id="page-selection-to">To</InputLabel>
                                        <Select
                                            labelId="page-selection-to"
                                            id="page-selection-to"
                                            value={effectivePageSelectionToValue}
                                            onChange={(e) => onChangeAiConfig({ page_selection_to: e.target.value })}
                                            label="To"
                                        >
                                            {readLessonPagePool
                                                .filter((_, idx) => {
                                                    const fromPid = resolveReadLessonPageValue(ai_grading_config.page_selection_from);
                                                    const fromIdx = readLessonPageIdToIndex.get(fromPid) ?? 0;
                                                    return idx >= fromIdx;
                                                })
                                                .map((page) => (
                                                <MenuItem key={page.pageId} value={parseInt(page.pageId, 10)}>{page.NumberMasked || `Page ${page.pageId}`}</MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </Col>
                            </Row>
                        </AiconfigWrapper>
                    )}
                    <Row style={{ justifyContent: "space-between", marginBottom: 16 }}>
                        <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
                        <Button
                            variant="contained"
                        color="primary"
                        startIcon={<Add />}
                            onClick={() => {
                                onAddQuestion()
                            }}
                            disabled={buttonDisabled}
                        >
                            Add question
                        </Button>
                        {questions.length >= 2 && (
                            <Button
                                variant="outlined"
                                color="primary"
                                startIcon={<DragIndicatorIcon />}
                                onClick={() => {
                                    setReorderList(cloneDeep(questions));
                                    setRearrangeModalOpen(true);
                                }}
                                disabled={buttonDisabled}
                            >
                                Rearrange Questions
                            </Button>
                        )}
                        </div>
                        <AutoSelectStandardsModal
                            booksAllList={booksAllList}
                            bookId={bookId}
                            pageId={pageId}
                            questions={questions}
                            setQuestions={setQuestions}
                            buttonDisabled={buttonDisabled}
                            setButtonDisabled={setButtonDisabled}
                            pages={getBookData?.pages || []}
                        />
                    </Row>
                        {questions.length > 0 ? <InnerWrapper ref={innerRef} id='previewInner' className='previewFormAssistCstm'>
                            {map(questions, (question, index) => {
                                if (question.type === 'audioMultipleChoice') {
                                   return renderAudioWithMultiChoice(question, index)
                                }
                                else if (question.type === 'audioEssay') {
                                   return renderAudioWithWrittenResponse(question, index)
                                }
                                return (<RelativeContainer key={question._uid ?? question.id + index}>
                                    <Row gutter={[24, 24]} style={{ justifyContent: "flex-end", display: "flex" }}>
                                        <IconButton onClick={() => { onDeleteQuestion(question) }} style={{ padding: 0, marginRight: 10 }}>
                                            <Delete color="secondary" />
                                        </IconButton>
                                    </Row>
                                    <QuestionContainer key={question._uid ?? question.id} >
                                        <Detail index={index}>Question {index + 1} of {questions.length}</Detail>
                                        <Question style={{ marginTop: 16 }}>
                                            <FormControl variant="outlined" className={classes.formControl}>
                                                <InputLabel style={{ backgroundColor: 'white', paddingRight: 5 }} id="type">Question Type</InputLabel>
                                                <Select
                                                    labelId="type"
                                                    id="type"
                                                    value={question.type}
                                                    required
                                                    onChange={(v) => {
                                                        onChangeQuestionType(v.target.value, question)
                                                    }}
                                                    label="Type"
                                                >
                                                    {QUESTION_TYPE_ACTIVITY_NON_NATIVE?.map(v => (<MenuItem key={v.value} value={v.value}>{v.type}</MenuItem>))}
                                                </Select>
                                            </FormControl>
                                        </Question>

                                        <Question>
                                        <label style={{ marginBottom: 0 , fontSize: 12, fontWeight: 400 }}>{showInstructionLabel(question) }</label>
                                            <TextEditor
                                                key={`question-editor-${question._uid ?? question.id}`}
handleChange={(value) => {
                                                onChangeQuestionData(value, "question", question)
                                            }}
                                                placeholder={(question.type !== 'match' && question.type !== 'filling' && question.type !== 'audioToImage') ? 'Type your question here...' : 'Type your instruction here...'}
                                                value={question.question || ''}
                                                autoFocus={false}
                                                disabled={buttonDisabled}
                                                containerClassName='question-ebook-text-field'
                                            />
                                        </Question>
                                        {AI_GRADED_QUESTION_TYPES.includes(question.type) && (
                                            <Question style={{ marginTop: 16 }} className="floatingLabelBG">
                                                {renderGradePageRefAutocomplete(question, index)}
                                                <TextField
                                                    label="Grade Prompt"
                                                    variant="outlined"
                                                    fullWidth
                                                    multiline
                                                    rows={2}
                                                    InputLabelProps={{ shrink: true }}
                                                    onChange={(e) => {
                                                        onChangeQuestionData(e.target.value, "grade_prompt", index);
                                                    }}
                                                    value={question.grade_prompt || ""}
                                                    placeholder="Optional prompt for AI grading..."
                                                    disabled={buttonDisabled}
                                                />
                                            </Question>
                                        )}
                                        {question.type === 'essay' ? <Question className='expectedReson' style={{ marginTop: 6 }}>
                                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
                                                <label style={{display: 'inline-block', textTransform: 'uppercase' }}>Expected Response</label>
                                                <div className=''>
                                                <Button 
                                                 variant="contained"
                                                 color="primary"
                                                 disabled={buttonDisabled}
                                                 onClick={() => onAddExpectedAnswer(index)}
                                                 className='minWith'
                                                  startIcon={<Add />}>
                                                    Add Expected Response</Button>
                                                </div>
                                            </div>
                                            {Array.isArray(question.expected_answer) && question.expected_answer.length > 0 && (
                                                question.expected_answer.map((answer, answerIndex) => (
                                                    <div key={answerIndex} style={{ marginBottom: 12, position: 'relative' }}>
                                                        <div className='w-full flex items-center' style={{ marginBottom: 8, alignItems: 'center', justifyContent: 'space-between', display: 'flex' }}>
                                                            <label style={{ marginLeft: 8 }}>Expected Response ({answerIndex + 1})</label>
                                                                <IconButton
                                                                    onClick={() => onDeleteExpectedAnswer(index, answerIndex)}
                                                                    disabled={buttonDisabled}
                                                                    size="small"
                                                                    style={{ 
                                                                        marginLeft: "auto",
                                                                        color: COLOR.red,
                                                                        backgroundColor: 'rgba(255, 255, 255, 0.9)'
                                                                    }}
                                                                >
                                                                    <Delete />
                                                            </IconButton>
                                                        </div>
                                                        <TextEditor
                                                            handleChange={(value) => {
                                                                onChangeExpectedAnswer(index, answerIndex, value)
                                                            }}
                                                            placeholder="Type expected response here..."
                                                            value={answer || ''}
                                                            autoFocus={false}
                                                            disabled={buttonDisabled}
                                                            containerClassName='question-ebook-text-field'
                                                        />
                                                    </div>
                                                ))
                                            )}
                                        </Question> : null}
                                        {question.type !== 'audioEssay' && question.type !== 'audioMultipleChoice' && question.type !== 'audioTrueFalse' && question.type !== 'audio' && question.type !== 'picture' && question.type !== 'multipleChoice'  && question.type !== 'trueFalse' && question.type !== 'video' && question.type !== 'filling' && question.type !== 'match' && question.type !== 'audioToImage' && question.type !== 'photoCollage' && (
                                        <div className='setupQuesInfo'>
                                           <InfoOutlineIcon /><label>Text below will display the student answer...</label>
                                        </div>
                                       )}
                                        {(() => {
                                            const ebookGradeLevels = getBookData?.grade_levels || [];
                                            
                                            if (Array.isArray(ebookGradeLevels) && ebookGradeLevels.length > 0) {
                                                return map(ebookGradeLevels, (gradeLevelItem, stateIndex) => {
                                                    const stateCode = get(gradeLevelItem, 'state', '');
                                                    const state = getStateNameFromCode(stateCode) || stateCode;
                                                    const gradeLevel = get(gradeLevelItem, 'grade_level', '');
                                                    
                                                    if (!state) return null;
                                                    
                                                    const standardObj = {
                                                        standard_name: state,
                                                        grade: gradeLevel
                                                    };
                                                    
                                                    const existingStateStandard = question.state_standard && Array.isArray(question.state_standard) 
                                                        ? question.state_standard.find(s => {
                                                            const sState = typeof s === 'string' ? s : get(s, 'standard_name', '');
                                                            return statesMatch(sState, state);
                                                        })
                                                        : null;
                                                    
                                                    const standardArray = existingStateStandard 
                                                        ? (Array.isArray(existingStateStandard?.standard) ? existingStateStandard.standard : (existingStateStandard?.standard ? [existingStateStandard.standard] : []))
                                                        : [];
                                                    
                                                    const filterOptions = standards?.filter((k) => {
                                                        const standardStatus = get(k, 'status', false);
                                                        if (standardStatus !== true) return false;
                                                        const standardState = get(k, 'state', '');
                                                        const standardGradeLevel = get(k, 'grade_level', '');
                                                        
                                                        if (!statesMatch(standardState, state)) return false;
                                                        
                                                        if (!gradeLevel) return true;
                                                        
                                                        const ebookGrades = String(gradeLevel).split(',').map(g => g.trim()).filter(g => g);
                                                        if (ebookGrades.length === 0) return true;
                                                        
                                                        if (!standardGradeLevel) return true;
                                                        
                                                        const standardGrades = String(standardGradeLevel).split(',').map(g => g.trim()).filter(g => g);
                                                        
                                                        return ebookGrades.some(ebookGrade => 
                                                            standardGrades.some(standardGrade => compareGradesForIllinoisCommonCore(ebookGrade, standardGrade, standardState))
                                                        );
                                                    })?.map((k) => k.abbr) || [];
                                                    
                                                    const selectedStandards = standardArray;
                                                    
                                                    if (filterOptions.length === 0) {
                                                        return null;
                                                    }
                                                    
                                                    return (
                                                        <div key={stateIndex} style={{ marginBottom: '8px' }}>
                                                            <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '8px' }}>
                                                                <label style={{ fontSize: 14, fontWeight: 500 }}>{renderLabel(state)}</label>
                                                                {selectedStandards.length > 0 && (
                                                                    <IconButton
                                                                        size="small"
                                                                        onClick={(e) => {
                                                                            e.preventDefault();
                                                                            e.stopPropagation();
                                                                            setStandardInfoModal({ 
                                                                                open: true, 
                                                                                standardAbbrs: selectedStandards,
                                                                                stateStandard: [{
                                                                                    ...standardObj,
                                                                                    standard: selectedStandards
                                                                                }]
                                                                            });
                                                                        }}
                                                                        style={{ padding: '4px', pointerEvents: 'auto' }}
                                                                    >
                                                                        <InfoOutlined style={{ fontSize: '18px', color: '#1890ff', cursor: 'pointer' }} />
                                                                    </IconButton>
                                                                )}
                                                            </div>
                                                            <MultiSelect
                                                                label=""
                                                                InputLabelProps={{ shrink: true }}
                                                                options={filterOptions.length > 0 ? filterOptions : filteredStandardsOptions}
                                                                selectedValue={selectedStandards}
                                                                onSelect={(v) => {
                                                                    const selectedArray = typeof v === 'string' ? (v ? v.split(',').map(s => s.trim()).filter(s => s) : []) : (Array.isArray(v) ? v : []);
                                                                    handleStateStandardChange(selectedArray, index, stateIndex, standardObj);
                                                                }} 
                                                            />
                                                        </div>
                                                    );
                                                });
                                            }
                                            
                                            return null;
                                        })()}                                                        

                                        {isStandardExam && <Question style={{ marginTop: 16 }} className="floatingLabelBG">
                                            <TextField
                                                label={"Explanation"}
                                                variant="outlined"
                                                fullWidth
                                                multiline
                                                rows={1}
                                                required
                                                InputLabelProps={{ shrink: true, required: true }}
                                                onChange={(e) => {
                                                    onChangeQuestionData(e.target.value, "explanation", index)
                                                }}
                                                value={question.explanation || ""}
                                                placeholder="Enter explanation for the correct answer..."
                                            />
                                        </Question>}

                                        {isStandardExam && <Question style={{ marginTop: 16 }} className="floatingLabelBG">
                                            <TextField
                                                label={"Standard Story"}
                                                variant="outlined"
                                                fullWidth
                                                multiline
                                                rows={2}
                                                onChange={(e) => {
                                                    onChangeQuestionData(e.target.value, "standard_story", index)
                                                }}
                                                value={question.standard_story || ""}
                                                placeholder="Enter standard story for the question..."
                                            />
                                        </Question>}

                                        {question.type === 'picture' && (
                                            <PictureAssignment
                                                source={question.pictures}
                                                handlePicture={(v) => {
                                                    onChangeQuestionData(v, "pictures", index)
                                                }}
                                                // style={{marginTop: question.pictures ? "50px" : ""}}
                                                style={{ marginTop: question.pictures ? (window.innerWidth >= 1024 ? "130px" : "85px") : "" }}
                                                imageClassName={`assignment-image ${isTablate ? "assignmentTabImg" : ""}`}
                                                containerClassName="assignment-ebook"
                                                setButtonDisabled={(value) => setButtonDisabled(value)}
                                                showImagePicker
                                            />
                                        )}
                                        <Content>
                                            {question.type === 'email' && (
                                                <Row gutter={[0, 24]}>
                                                    <Col span={24}>
                                                        <TextEditor
                                                            handleChange={() => { }}
                                                            value={''}
                                                            autoFocus={false}
                                                            disabled={true}
                                                        />
                                                    </Col>
                                                </Row>
                                            )}
                                            {question.type === 'essay' && (
                                                <Row gutter={[0, 24]}>
                                                    <Col span={24}>
                                                        <TextEditor
                                                            handleChange={() => { }}
                                                            value={''}
                                                            autoFocus={false}
                                                            disabled={true}
                                                        />
                                                    </Col>
                                                </Row>
                                            )}
                                            {question.type === 'multipleChoice' && (
                                                <>
                                                    <FormControl variant="outlined" className={classes.formControl} style={{ marginBottom: 16 }}>
                                                        <InputLabel id="type" style={{ backgroundColor: "#fff" }}>Number of options</InputLabel>
                                                        <Select
                                                            labelId="level"
                                                            id="level"
                                                            required={false}
                                                            value={get(question, "options.length", 4)}
                                                            onChange={(v) => {
                                                                onChangeOptionsLength(index, parseInt(v.target.value))
                                                            }}
                                                            label="Type"
                                                        >
                                                            <MenuItem value={2}>2</MenuItem>
                                                            <MenuItem value={3}>3</MenuItem>
                                                            <MenuItem value={4}>4</MenuItem>
                                                            <MenuItem value={5}>5</MenuItem>
                                                            <MenuItem value={6}>6</MenuItem>
                                                            <MenuItem value={7}>7</MenuItem>
                                                            <MenuItem value={8}>8</MenuItem>
                                                            <MenuItem value={9}>9</MenuItem>
                                                            <MenuItem value={10}>10</MenuItem>
                                                        </Select>
                                                    </FormControl>
                                                    {map(get(question, "options", ['', '', '', '']), (option, optId) => (
                                                        <Row key={optId} style={{ marginBottom: '8px' }}>
                                                            <RadioGroup style={{ display: "flex", flexDirection: "row", width: "100%" }} aria-label="options" name={`options-${index}`} value={`${question.answer}`} onChange={(e) => { onChangeQuestionData(parseInt(e.target.value), "answer", index) }}>
                                                                <Row style={{ width: "100%" }}>
                                                                    <RadioColumn span={2}>
                                                                        <FormControlLabel value={`${optId}`} checked={optId == question.answer} control={<Radio />} />
                                                                    </RadioColumn>
                                                                    <Col span={22}>
                                                                        <Acent inputRef={optionRefs.current[`${index}-${optId}`]} setValue={v => onchangeOption(index, optId, v)} style={{ marginBottom: 5, display: "flex", justifyContent: "flex-end" }} />
                                                                        <TextField
                                                                            id={`question${index + optId}`}
                                                                            name="options"
                                                                            label={`option ${LABEL[optId]}`}
                                                                            InputLabelProps={{ shrink: true, required: true }}
                                                                            type="text"
                                                                            required
                                                                            inputRef={ref => optionRefs.current[`${index}-${optId}`] = ref}
                                                                            variant="outlined"
                                                                            onChange={e => {
                                                                                onchangeOption(index, optId, e.target.value)
                                                                            }}
                                                                            value={option}
                                                                        />

                                                                    </Col>

                                                                </Row>


                                                            </RadioGroup>

                                                        </Row>
                                                    ))}
                                                </>
                                            )}
                                            {question.type === 'multipleResponse' && (
                                                <>
                                                    <FormControl variant="outlined" className={classes.formControl} style={{ marginBottom: 16 }}>
                                                        <InputLabel id="type" style={{ backgroundColor: "#fff" }}>Number of options</InputLabel>
                                                        <Select
                                                            labelId="level"
                                                            id="level"
                                                            required={false}
                                                            value={get(question, "options.length", 4)}
                                                            onChange={(v) => {
                                                                onChangeOptionsLength(index, parseInt(v.target.value))
                                                            }}
                                                            label="Type"
                                                        >
                                                            <MenuItem value={2}>2</MenuItem>
                                                            <MenuItem value={3}>3</MenuItem>
                                                            <MenuItem value={4}>4</MenuItem>
                                                            <MenuItem value={5}>5</MenuItem>
                                                            <MenuItem value={6}>6</MenuItem>
                                                            <MenuItem value={7}>7</MenuItem>
                                                            <MenuItem value={8}>8</MenuItem>
                                                            <MenuItem value={9}>9</MenuItem>
                                                            <MenuItem value={10}>10</MenuItem>
                                                        </Select>
                                                    </FormControl>
                                                    {map(get(question, "options", ['', '', '', '']), (option, optId) => (
                                                        <Row key={optId} style={{ marginBottom: '8px' }}>
                                                            <Row style={{ width: "100%" }}>
                                                                <Col span={2} style={{ height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', paddingTop: '22px' }}>
                                                                    <FormControlLabel 
                                                                        control={
                                                                            <Checkbox 
                                                                                checked={Array.isArray(question.answer) && question.answer.includes(optId.toString())}
                                                                                onChange={(e) => {
                                                                                    const currentAnswers = Array.isArray(question.answer) ? [...question.answer] : [];
                                                                                    if (e.target.checked) {
                                                                                        currentAnswers.push(optId.toString());
                                                                                    } else {
                                                                                        currentAnswers.splice(currentAnswers.indexOf(optId.toString()), 1);
                                                                                    }
                                                                                    onChangeQuestionData(currentAnswers, "answer", index);
                                                                                }}
                                                                            />
                                                                        }
                                                                        label=""
                                                                    />
                                                                </Col>
                                                                <Col span={22}>
                                                                    <Acent inputRef={optionRefs.current[`${index}-${optId}`]} setValue={v => onchangeOption(index, optId, v)} style={{ marginBottom: 5, display: "flex", justifyContent: "flex-end" }} />
                                                                    <TextField
                                                                        id={`question${index + optId}`}
                                                                        name="options"
                                                                        label={`option ${LABEL[optId]}`}
                                                                        InputLabelProps={{ shrink: true, required: true }}
                                                                        type="text"
                                                                        required
                                                                        inputRef={ref => optionRefs.current[`${index}-${optId}`] = ref}
                                                                        variant="outlined"
                                                                        onChange={e => {
                                                                            onchangeOption(index, optId, e.target.value)
                                                                        }}
                                                                        value={option}
                                                                    />
                                                                </Col>
                                                            </Row>
                                                        </Row>
                                                    ))}
                                                </>
                                            )}
                                            {(question.type === 'audio' || question.type === 'audioEssay' || question.type == 'audioTrueFalse' || question.type === 'audioToImage') && (
                                                <>
                                                    {question.type != 'audioTrueFalse' && question.type != 'audioToImage' ? <Question style={{ marginBottom: 16 }}>
                                                        <FormControl variant="outlined" className={classes.formControl}>
                                                            <InputLabel id="durations">Time</InputLabel>
                                                            <Select
                                                                labelId="durations"
                                                                id="durations"
                                                                value={question.duration || '60'}
                                                                required
                                                                onChange={(v) => {
                                                                    onChangeQuestionData(v.target.value, "duration", index)
                                                                }}
                                                                label="Type"
                                                            >
                                                                {DURATIONS.map(v => (<MenuItem value={v.value}>{v.label}</MenuItem>))}
                                                            </Select>
                                                        </FormControl>
                                                    </Question> : null}
                                                    <Question style={{ marginBottom: 16 }}>
                                                        <AudioRecorder
                                                            handleAudio={(v) => {
                                                                onChangeQuestionData(v, "audio", index)
                                                                trenacriptAudio(v)
                                                            }}
                                                            index={index}
                                                            currentSubmission={{}}
                                                            refresh={() => { }}
                                                            source={question.audio}
                                                            hasSaveButton
                                                            message={`Record a question`}
                                                            setButtonDisabled={(value) => setButtonDisabled(value)}
                                                        />
                                                    </Question>
                                                    <Question style={{ marginBottom: 16, textAlign: "center" }}>
                                                        OR
                                                    </Question>
                                                    <AudioPicker
                                                        message={"Upload a audio file for question..."}
                                                        onChange={v => {
                                                            onChangeQuestionData(v, "audio", index)
                                                            trenacriptAudio(v)
                                                        }}
                                                        setButtonDisabled={(value) => setButtonDisabled(value)}
                                                    />
                                                    {question.type !== 'audioTrueFalse' && question.type !== 'audioToImage' && (
                                                        <div className='setupQuesInfo' style={{ marginBottom: 10 }}><InfoOutlineIcon /><label>Text below will display the student answer...</label></div>
                                                    )}
                                                    {question.type === 'audio' && (
                                                        <AudioRecorder
                                                            maxTime={question.duration || 20}
                                                            handleAudio={() => { }}
                                                            index={index}
                                                            currentSubmission={{}}
                                                            refresh={() => { }}
                                                            isPreview
                                                        />
                                                    )}
                                                    {question.type === 'audioEssay' && (
                                                        <Row gutter={[0, 24]}>
                                                            <Col span={24}>
                                                                <TextEditor
                                                                    handleChange={() => { }}
                                                                    value={''}
                                                                    autoFocus={false}
                                                                    disabled={true}
                                                                    containerClassName='question-ebook-text-field'
                                                                />
                                                            </Col>
                                                        </Row>
                                                    )}
                                                    {question.type === 'audioToImage' && (
                                                        <Row gutter={[0, 24]}>
                                                            <Col span={24}>
                                                                <StyledFormControl>
                                                                    <StyledInputLabel id="type">
                                                                        Student can upload up to {question.studentCanUploadImages || 6} images.
                                                                    </StyledInputLabel>
                                                                    <Select
                                                                        labelId="type"
                                                                        id="type"
                                                                        value={question.studentCanUploadImages || 6}
                                                                        required
                                                                        onChange={(v) => {
                                                                            onChangeQuestionData(v.target.value, 'studentCanUploadImages', index);
                                                                        }}
                                                                        label="Select Collage Count"
                                                                    >
                                                                        {imageUpload?.map((v) => (
                                                                            <MenuItem key={v.value} value={v.value}>
                                                                                {v.value}
                                                                            </MenuItem>
                                                                        ))}
                                                                    </Select>
                                                                </StyledFormControl>
                                                                 <div className='setupQuesInfo' style={{ marginBottom: 10 , marginTop: 0 }}><InfoOutlineIcon /><label>Text below will display the student answer...</label></div>
                                                                <PictureAssignment
                                                                    disabled={true}
                                                                    source={question.image}
                                                                    handlePicture={(v) => {
                                                                        onChangeQuestionData(v, "image", index)
                                                                    }}
                                                                />
                                                            </Col>
                                                        </Row>
                                                    )}
                                                    {question.type === 'audioTrueFalse' && (
                                                        map(get(question, "options", ['Cierto', 'Falso']), (option, optId) => (
                                                            <Row key={optId} style={{ marginBottom: '8px' }}>
                                                                <RadioGroup style={{ display: "flex", flexDirection: "row", width: "100%" }} aria-label="options" name={`options-${index}`} value={`${question.answer}`} onChange={(e) => { onChangeQuestionData(parseInt(e.target.value), "answer", index) }}>
                                                                    <Row style={{ width: "100%" }}>
                                                                        <RadioColumn span={2}>
                                                                            <FormControlLabel value={`${optId}`} checked={optId == question.answer} control={<Radio />} />
                                                                        </RadioColumn>
                                                                        <Col span={22}>
                                                                            <Acent inputRef={optionRefs.current[`${index}-${optId}`]} setValue={v => onchangeOption(index, optId, v, 'audioTrueFalse')} style={{ marginBottom: 5, display: "flex", justifyContent: "flex-end" }} />
                                                                            <TextField
                                                                                id={`question${index + optId}`}
                                                                                name="options"
                                                                                label={`option ${LABEL[optId]}`}
                                                                                InputLabelProps={{ shrink: true, required: true }}
                                                                                type="text"
                                                                                required
                                                                                inputRef={ref => optionRefs.current[`${index}-${optId}`] = ref}
                                                                                variant="outlined"
                                                                                onChange={e => {
                                                                                    onchangeOption(index, optId, e.target.value, 'audioTrueFalse')
                                                                                }}
                                                                                value={option}
                                                                            />

                                                                        </Col>

                                                                    </Row>


                                                                </RadioGroup>

                                                            </Row>
                                                        ))
                                                    )}
                                                </>
                                            )}
                                            {question.type === 'video' && (
                                                <>
                                                    <AssignmentVideo
                                                        states={{ index, question }}
                                                        funcObj={{
                                                            onChangeQuestionData,
                                                            setButtonDisabled,
                                                            trenacriptAudio
                                                        }}
                                                    />
                                                </>
                                            )}
                                            {/* Match-Making */}
                                            {question.type === 'match' && (
                                                <MatchMaking
                                                    index={index}
                                                    question={question}
                                                    optionRefs={optionRefs}
                                                    onAddMoreOption={onAddMatchOption}
                                                    onChangeType={onChangeQuestionData}
                                                    onDeleteMatchOption={onDeleteMatchOption}
                                                    onchangeOptionMatch={onchangeOptionMatch}
                                                    setButtonDisabled={(value) => setButtonDisabled(value)}
                                                    showImagePicker
                                                />
                                            )}
                                            {(question.type === 'filling' || question.type === 'fillingImage') && (
                                                <>
                                                    <AssignmentFormFillInBlanksComp
                                                        refs={{
                                                            answerRefs,
                                                            optionRefs
                                                        }}
                                                        states={{
                                                            index,
                                                            question,
                                                            questions,
                                                            optionStates,
                                                            isEditing
                                                        }}
                                                        funcObj={{
                                                            onAddOption,
                                                            onchangeOptionFilling,
                                                            onDeleteOption,
                                                            handleInputChange,
                                                            onUpdateAnswer,
                                                            getInputValue,
                                                            makeAnswerSubmitHandler,
                                                            toggleDropdown,
                                                            toggleEditor,
                                                            handlePictureFilling,
                                                            setButtonDisabled,
                                                            onChangeQuestionData,
                                                        }}
                                                        SelectAnswerDropDown={SelectAnswerDropDown}
                                                        showImagePicker={true}
                                                    />
                                                </>
                                            )}

                                    {question?.type === "photoCollage" && 
                                           <>
                                            <AssignmentPhotoCollage states={{ index, question, isPreview: true, selectData: true, collageLength: question?.collageLength, frameCollage: question?.collageFrame,showFullPreview:true  }} funcObj={{ onChangeQuestionData }} />
                                            </>
                                        }
                                            {question.type === 'twoMinAudio' && (
                                                <>
                                                    <AudioRecorder
                                                        maxTime={120}
                                                        handleAudio={() => { }}
                                                        refresh={() => { }}
                                                        isPreview
                                                        setButtonDisabled={(value) => setButtonDisabled(value)}
                                                    />
                                                </>
                                            )}
                                            {question.type === 'trueFalse' && (
                                                <>
                                                    {map(get(question, "options", ['Cierto', 'Falso']), (option, optId) => (
                                                        <Row key={optId} style={{ marginBottom: '8px' }}>
                                                            <RadioGroup style={{ display: "flex", flexDirection: "row", width: "100%" }} aria-label="options" name={`options-${index}`} value={`${question.answer}`} onChange={(e) => { onChangeQuestionData(parseInt(e.target.value), "answer", index) }}>
                                                                <Row style={{ width: "100%" }}>
                                                                    <RadioColumn span={2}>
                                                                        <FormControlLabel value={`${optId}`} checked={optId == question.answer} control={<Radio />} />
                                                                    </RadioColumn>
                                                                    <Col span={22}>
                                                                        <Acent inputRef={optionRefs.current[`${index}-${optId}`]} setValue={v => onchangeOption(index, optId, v, 'trueFalse')} style={{ marginBottom: 5, display: "flex", justifyContent: "flex-end" }} />
                                                                        <TextField
                                                                            id={`question${index + optId}`}
                                                                            name="options"
                                                                            label={`option ${LABEL[optId]}`}
                                                                            InputLabelProps={{ shrink: true, required: true }}
                                                                            type="text"
                                                                            required
                                                                            inputRef={ref => optionRefs.current[`${index}-${optId}`] = ref}
                                                                            variant="outlined"
                                                                            onChange={e => {
                                                                                onchangeOption(index, optId, e.target.value, 'trueFalse')
                                                                            }}
                                                                            value={option}
                                                                        />

                                                                    </Col>

                                                                </Row>


                                                            </RadioGroup>

                                                        </Row>
                                                    ))}
                                                </>
                                            )}

                                            {question.type === 'picture' && (
                                               <PictureAssignmentType 
                                                states={{question,index}}
                                                funcObj={{onChangeQuestionData}}
                                            />
                                            )}
                                        </Content>
                                    </QuestionContainer>
                                </RelativeContainer>)
                            })}
                    </InnerWrapper> : null}
                    {errors.length > 0 ? <Row style={{ marginTop: 10, marginRight: 0, marginLeft: 0, flexDirection: "column", display: "flex" }}>
                        {errors.map(v => (<Typography variant="subtitle2" key={v.type} style={{ whiteSpace: "pre-wrap" }} color="error">
                            * {get(v, "message")}
                        </Typography>))}
                    </Row> : null}
                    <Row gutter={[24, 24]} style={{ marginTop: 10, marginRight: 0, marginLeft: 0 }}>
                        <Button fullWidth
                            onClick={onSubmit}
                            disabled={questions.length == 0 || (!displayName || displayName.length == 0) || loading || buttonDisabled}
                            variant="contained"
                            color="primary">
                            {loading ? <Loading white size={15} /> : null} {isEditing ? "Update" : "Create"}
                        </Button>
                    </Row>
                </Col>
            </Row>
        </Wrapper>
        </Drawer>
        <Modal
            title="Rearrange Questions"
            open={rearrangeModalOpen}
            onCancel={() => setRearrangeModalOpen(false)}
            width={520}
            zIndex={1100}
            footer={[
                <AntButton key="cancel" onClick={() => setRearrangeModalOpen(false)}>
                    Cancel
                </AntButton>,
                <AntButton
                    key="done"
                    type="primary"
                    onClick={() => {
                        const reorderedWithIds = reorderList.map((q, index) => ({
                            ...q,
                            id: index + 1,
                        }));
                        setQuestions(reorderedWithIds);
                        setRearrangeModalOpen(false);
                    }}
                >
                    Done
                </AntButton>,
            ]}
        >
            {reorderList.length > 0 && (
                <RearrangeQuestionsList
                    reorderList={reorderList}
                    setReorderList={setReorderList}
                />
            )}
        </Modal>
        <StandardsModal
            open={standardInfoModal.open}
            onClose={() => {
                setStandardInfoModal({ open: false, standardAbbrs: [], stateStandard: null });
            }}
            standardAbbrs={standardInfoModal.standardAbbrs}
            stateStandard={standardInfoModal.stateStandard}
            standards={standards}
            enabledStateCodes={enabledStateCodes}
            userRole={currentUser?.role}
        />
        </SentryWrap>
    );
};

const mapStateToProps = state => ({
    currentClass: state.currentClass,
    userClasses: state.userClasses,
    booksAllList: state.booksAllList,
    activities: state.activities,
    currentUser: state.currentUser
});


export default connect(mapStateToProps, null)(AssignmentForm);